export default {
    'app.name': 'Filoteca',
    'update.title': 'Actualización',
    'update.text': 'Hay una versión nueva de Filoteca ({version}). ¿Descargarla e instalarla ahora?',
    'update.manual': 'Hay una versión nueva de Filoteca ({version}). Descárgala en {url}.',
    'update.migrate': 'Filoteca tiene una app nueva e independiente (sin servidor ni cuenta), que es la que seguirá actualizándose. Instálala desde {url} y, cuando la tengas, ya puedes desinstalar esta. ¿Abrir la descarga ahora?',
    'update.downloading': 'Descargando la actualización…',
    'update.installing': 'Abriendo el instalador…',
    'update.failed': 'No se pudo instalar la actualización. Puedes descargarla en {url}.',
    'update.upToDate': 'Filoteca está actualizada',
    'update.webReady': 'Hay una versión nueva de Filoteca',
    'update.reload': 'Actualizar',
    'update.check': 'Buscar actualizaciones',
    'settings.license': 'Licencia',
    'license.title': 'Licencia de Filoteca',
    'license.active': 'Licencia activa',
    'license.planLife': 'Pago único',
    'license.planSub': 'Suscripción',
    'license.until': 'Renovada hasta {date}',
    'license.keyLabel': 'Clave de licencia',
    'license.activate': 'Activar licencia',
    'license.fromPhone': 'Escribir la clave desde el móvil',
    'license.buy': 'Comprar licencia',
    'license.buyHelp': 'Compra tu licencia desde el móvil (escanea el código) o en esta dirección:',
    'license.activated': 'Licencia activada. ¡Gracias!',
    'license.release': 'Liberar este dispositivo',
    'license.releaseHelp': 'Si vas a usar la clave en otra tele o móvil, libera antes este dispositivo.',
    'license.releaseConfirm': 'Este dispositivo dejará de tener licencia y podrás usar la clave en otro. ¿Continuar?',
    'license.released': 'Dispositivo liberado',
    'license.lost.revoked': 'Tu licencia se ha dado de baja.',
    'license.lost.expired': 'Tu suscripción ha vencido.',
    'license.lost.released': 'Esta licencia se liberó desde este dispositivo u otro.',
    'license.lost.invalid_token': 'No se pudo validar la licencia guardada.',
    'license.lost.stale': 'Hace mucho que no se conecta a internet para renovar la licencia. Conecta y ábrela de nuevo.',
    'license.err.format': 'La clave debe tener el formato FILO-XXXX-XXXX-XXXX.',
    'license.err.invalid_key': 'Esa clave no existe. Revísala.',
    'license.err.revoked': 'Esa licencia ya no está vigente.',
    'license.err.expired': 'Esa licencia ha caducado.',
    'license.err.device_limit': 'Esa clave ya está en {max} dispositivos ({devices}). Libera uno desde Ajustes → Licencia en ese dispositivo.',
    'license.err.network': 'No se pudo conectar con el servidor de licencias. Comprueba tu conexión.',
    'license.err.rate_limited': 'Demasiados intentos. Espera unos minutos.',
    'license.err.server': 'El servidor de licencias no contestó bien. Inténtalo más tarde.',
    'phone.licenseAdded': 'Licencia activada',
    'settings.licenseSubActive': 'Activa',
    'license.free': 'Sin licencia',
    'license.freeHelp': 'Sin licencia, los canales públicos por país no tienen límite. Con tus propias fuentes puedes ver estos títulos; se cuentan al verlos un rato y después siguen siendo tuyos. La licencia (gratuita durante la beta) quita los límites; Filoteca no vende ni incluye contenido.',
    'license.kind.live': 'Canales',
    'license.kind.vod': 'Películas',
    'license.kind.series': 'Series',
    'license.limit.live': 'Has usado todos los canales de tus fuentes que se pueden ver sin licencia.',
    'license.limit.vod': 'Has usado todas las películas de tus fuentes que se pueden ver sin licencia.',
    'license.limit.series': 'Has usado todas las series de tus fuentes que se pueden ver sin licencia.',
    'license.slotUsed.live': 'Canal usado sin licencia. Te quedan {left}.',
    'license.slotUsed.vod': 'Película usada sin licencia. Te quedan {left}.',
    'license.slotUsed.series': 'Serie usada sin licencia. Te quedan {left}.',
    'license.badge.live': 'Sin licencia · {used} de {limit} canales',
    'license.badge.vod': 'Sin licencia · {used} de {limit} películas',
    'license.badge.series': 'Sin licencia · {used} de {limit} series',
    'license.banner': 'Con tus fuentes te quedan: {live} canales · {vod} películas · {series} series. Los canales públicos por país no tienen límite.',
    'settings.licenseSubFree': 'Sin licencia · quedan {live} canales, {vod} películas, {series} series',
    'support.title': 'Soporte',
    'support.sub': 'Cuenta un problema o propón una mejora (solo con licencia)',
    'support.subAccount': 'Cuenta un problema o propón una mejora',
    'support.unreadValue': '{n} respuesta(s) nueva(s)',
    'support.unreadToast': 'Soporte ha respondido a tu ticket ({n}). Ajustes → Soporte.',
    'support.intro': 'Cuéntanos un problema o una idea. Te respondemos por aquí y por correo.',
    'support.left': 'Te quedan hoy {day} · este mes {month} · abiertos a la vez {open}',
    'support.new': 'Nuevo ticket',
    'support.none': 'Aún no has enviado ningún ticket.',
    'support.newReply': 'respuesta nueva',
    'support.kind': 'Tipo',
    'support.kind.problem': 'Problema',
    'support.kind.idea': 'Idea',
    'support.subject': 'Asunto',
    'support.message': 'Descripción',
    'support.messagePh': 'Qué pasa, en qué pantalla, qué esperabas…',
    'support.includeDiag': 'Incluir datos técnicos (versión de la app y del aparato)',
    'support.send': 'Enviar',
    'support.sent': 'Ticket enviado. ¡Gracias!',
    'support.sentNote': 'Hemos recibido tu ticket. Te responderemos aquí y por correo.',
    'support.reply': 'Tu respuesta',
    'support.you': 'Tú',
    'support.staff': 'Soporte',
    'support.closedNote': 'Este ticket está cerrado. Si necesitas algo más, abre uno nuevo.',
    'support.status.open': 'Abierto',
    'support.status.answered': 'Respondido',
    'support.status.closed': 'Cerrado',
    'support.needLicense': 'El soporte es para usuarios con licencia.',
    'support.needLicenseHelp': 'Activa tu licencia para enviar problemas e ideas y recibir respuesta.',
    'support.err.license': 'Tu licencia no está activa en este dispositivo. Ábrela en Ajustes → Licencia.',
    'support.err.session': 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
    'support.err.network': 'No se pudo conectar con el servidor. Comprueba tu conexión.',
    'support.err.unavailable': 'El soporte no está disponible ahora. Inténtalo más tarde.',
    'support.err.limit_open': 'Ya tienes el máximo de tickets abiertos. Espera a que se respondan o se cierren.',
    'support.err.limit_day': 'Has llegado al máximo de tickets de hoy. Vuelve mañana.',
    'support.err.limit_month': 'Has llegado al máximo de tickets de este mes.',
    'support.err.limit_replies': 'Has llegado al máximo de mensajes en este ticket.',
    'support.err.empty': 'Escribe un asunto y una descripción de al menos 10 caracteres.',
    'support.err.closed': 'Este ticket está cerrado.',
    'support.err.rate_limited': 'Demasiadas peticiones. Espera unos minutos.',
    'support.err.not_found': 'No se encontró ese ticket.',
    'voice.label': 'Buscar por voz',
    'voice.denied': 'Permite el micrófono para buscar por voz.',
    'voice.unavailable': 'Este aparato no tiene reconocimiento de voz.',
    'live.viewRows': 'Por categorías',
    'common.uncategorized': 'Sin categoría',
    'update.auto': 'Avisar de versiones nuevas',
    'update.autoSub': 'Al abrir la app, como mucho una vez al día. Solo se consulta la versión publicada.',
    'update.availableSub': 'Disponible la versión {version}',
    'app.updateAvailable': 'Hay una versión nueva de Filoteca: descárgala en {url}',
    'app.downloadApk': 'Descargar la app para Android / Android TV',
    'app.downloadApkSub': 'En la tele, con Downloader, escribe {url}',
    'nav.home': 'Inicio',
    'nav.live': 'TV en directo',
    'nav.movies': 'Películas',
    'nav.series': 'Series',
    'nav.guide': 'Guía',
    'nav.search': 'Buscar',
    'nav.menu': 'Menú',
    'nav.settings': 'Ajustes',
    'nav.mylist': 'Mi lista',

    'common.play': 'Reproducir',
    'common.resume': 'Reanudar',
    'common.restart': 'Desde el principio',
    'common.info': 'Más información',
    'common.cancel': 'Cancelar',
    'common.ok': 'Aceptar',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.close': 'Cerrar',
    'common.back': 'Volver',
    'common.retry': 'Reintentar',
    'common.all': 'Todo',
    'player.skipIntro': 'Saltar intro',
    'intro.title': "Intro de la serie",
    'intro.help': "Si el proveedor no marca la intro, márcala una vez y se podrá saltar en todos los episodios de esta serie.",
    'intro.current': "Intro marcada: de {start} a {end}.",
    'intro.markStart': "La intro empieza aquí ({time})",
    'intro.markEnd': "La intro acaba aquí ({time})",
    'intro.clear': "Quitar la marca de intro",
    'intro.startMarked': "Inicio marcado en {time}. Ahora, donde acabe la intro, pulsa «La intro acaba aquí».",
    'intro.needStart': "Marca primero dónde empieza la intro.",
    'intro.tooShort': "La intro debe durar al menos 5 segundos y acabar después de donde empieza.",
    'intro.saved': "Intro guardada: «Saltar intro» saldrá en los episodios de esta serie.",
    'intro.cleared': "Marca de intro quitada",
    'player.rememberHint': "El audio y los subtítulos que elijas se recuerdan para esta serie.",
    'player.skipCredits': 'Saltar créditos',
    'player.viewCredits': 'Ver créditos',
    'settings.syncServers': 'Sincronizar lo visto con mis servidores',
    'settings.syncServersSub': 'Guarda en Jellyfin, Emby y Plex lo que ves en Filoteca (posición y «visto») y trae lo que ya viste allí a «Continuar viendo»',
    'library.mine': 'Mis bibliotecas',
    'settings.onlyLibraries': 'Solo mis bibliotecas',
    'settings.onlyLibrariesSub': 'Muestra en Inicio, Películas, Series y Búsqueda solo lo de tus servidores y carpetas (Jellyfin, Emby, Plex y archivos); oculta canales, listas y Cine clásico',
    'report.title': 'Denunciar contenido',
    'report.sub': 'Avisa si algo vulnera tus derechos o la ley',
    'report.intro': 'Cuéntanos qué contenido y por qué. Lo revisamos y te respondemos por correo.',
    'report.targetArchive': 'Película de «Cine clásico»',
    'report.what': 'Qué contenido (título, canal, lista o dirección)',
    'report.kind': 'Motivo',
    'report.kind.copyright': 'Derechos de autor',
    'report.kind.illegal': 'Contenido ilegal',
    'report.kind.inappropriate': 'Contenido inapropiado',
    'report.kind.broken': 'No funciona o es incorrecto',
    'report.kind.other': 'Otro',
    'report.description': 'Descripción',
    'report.descriptionPh': 'Explica qué ocurre y por qué debería revisarse (mínimo 20 caracteres).',
    'report.email': 'Tu correo (para responderte)',
    'report.name': 'Tu nombre (opcional)',
    'report.role': 'Eres',
    'report.role.owner': 'Titular de los derechos',
    'report.role.representative': 'Representante del titular',
    'report.role.other': 'Otro',
    'report.rightsOwner': 'Titular de los derechos (persona o empresa)',
    'report.goodFaith': 'Declaro de buena fe que la información es exacta y que soy el titular o estoy autorizado/a a actuar en su nombre.',
    'report.signature': 'Firma (tu nombre completo)',
    'report.send': 'Enviar denuncia',
    'report.sent': 'Denuncia enviada. Referencia: {ref}',
    'report.sentNote': 'Te hemos enviado un acuse de recibo por correo.',
    'report.err.bad_email': 'Escribe un correo válido.',
    'report.err.description_short': 'Describe el problema con al menos 20 caracteres.',
    'report.err.copyright_fields': 'Una denuncia de derechos necesita el titular, la declaración marcada y tu firma.',
    'report.err.target_required': 'Indica sobre qué contenido es.',
    'report.err.unknown_target': 'Ese contenido no existe en Filoteca.',
    'report.err.rate_limited': 'Demasiadas denuncias seguidas. Inténtalo más tarde.',
    'report.err.network': 'No se pudo enviar. Revisa tu conexión.',
    'report.err.unavailable': 'El servicio no está disponible ahora.',
    'player.report': 'Denunciar',
    'report.targetChannel': 'Canal de una lista pública',
    'report.source': "Fuente",
    'report.prefillChannel': 'Canal «{name}»',
    'reports.admin.title': 'Denuncias',
    'reports.admin.sub': 'Revisar y atender las denuncias de contenido',
    'reports.admin.empty': 'No hay denuncias en este estado.',
    'survey.admin.title': 'Cuestionario de la beta',
    'survey.admin.sub': 'Ver las respuestas de los testeadores',
    'survey.admin.empty': 'Todavía no hay respuestas.',
    'docs.admin.title': 'Informes',
    'docs.admin.sub': 'Estudios y notas para decidir, guardados en el servidor',
    'docs.admin.empty': 'Todavía no hay informes.',
    'survey.admin.summary': 'Resumen',
    'survey.admin.responses': 'respuestas',
    'survey.admin.avgRec': 'Recomendación media',
    'survey.admin.ratings': 'Notas medias (1-5)',
    'survey.admin.bugs': 'Fallos',
    'survey.admin.would': 'La usaría',
    'survey.admin.tested': 'Qué se probó',
    'reports.admin.filter.new': 'Nuevas',
    'reports.admin.filter.reviewing': 'En revisión',
    'reports.admin.filter.hidden': 'Ocultas',
    'reports.admin.filter.removed': 'Retiradas',
    'reports.admin.filter.rejected': 'Rechazadas',
    'reports.admin.filter.closed': 'Cerradas',
    'reports.admin.filter.all': 'Todas',
    'reports.admin.hidden': 'Oculto',
    'reports.admin.about': 'Sobre',
    'reports.admin.from': 'De',
    'reports.admin.goodFaith': 'Buena fe',
    'reports.admin.date': 'Fecha',
    'reports.admin.note': 'Nota',
    'reports.admin.history': 'Historial',
    'reports.admin.act.review': 'Marcar en revisión',
    'reports.admin.act.hide': 'Ocultar mientras se revisa',
    'reports.admin.act.retire': 'Retirar definitivamente',
    'reports.admin.act.reject': 'Rechazar y volver a mostrar',
    'reports.admin.act.reply': 'Escribir al denunciante',
    'reports.admin.act.close': 'Cerrar',
    'reports.admin.text.optional': 'Texto para el denunciante (opcional)',
    'reports.admin.text.reply': 'Mensaje para el denunciante',
    'reports.admin.done': 'Hecho',
    'reports.admin.emailed': 'correo enviado',
    'reports.admin.notEmailed': 'no se envió correo',
    'reports.admin.err.nothing_to_hide': 'Esta denuncia no señala un título, lista o canal concreto: no hay nada que ocultar.',
    'reports.admin.err.empty': 'Escribe el texto.',
    'match.title': 'Corregir emparejado',
    'match.menu': 'Corregir emparejado',
    'match.intro': 'Si el servidor ha identificado mal este título, búscalo con otro nombre o año y elige el correcto. El cambio se hace en el servidor.',
    'match.name': 'Título',
    'match.year': 'Año',
    'match.search': 'Buscar',
    'match.confirm': '¿Usar «{title}»? Se cambiará en el servidor.',
    'match.apply': 'Aplicar',
    'match.done': 'Emparejado corregido',
    'match.forbidden': 'El servidor no te deja cambiarlo: hace falta una cuenta de administrador.',
    'match.error': 'No se pudo hacer. Revisa la conexión con el servidor.',
    'home.collections': 'Colecciones',
    'home.collectionCount': '{n} títulos',
    'home.libraryNews': 'Novedades en tus bibliotecas',
    'home.libraryNewsSeen': 'Marcar como vistas',
    'news.toast': '{n} novedades en tus bibliotecas (están en Inicio)',
    'news.see': 'Ver',
    'common.provider': 'Fuente',
    'common.seeAll': 'Ver todo',
    'common.loading': 'Cargando…',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.on': 'Activado',
    'common.off': 'Desactivado',
    'common.auto': 'Automático',
    'common.none': 'Ninguno',
    'common.results': '{count} resultados',
    'common.noResults': 'Sin resultados',
    'common.noResultsHint': 'Prueba con otra búsqueda o categoría.',
    'lib.noneMovies': 'Aún no hay películas',
    'lib.noneSeries': 'Aún no hay series',
    'live.none': 'Aún no hay canales',
    'lib.noneHint': 'Ninguna de tus fuentes trae este contenido. Añade una fuente que lo tenga o prueba otra en el filtro de fuentes.',
    'common.favorite': 'Mi lista',
    'common.favoriteAdd': 'Añadir a Mi lista',
    'common.favoriteRemove': 'Quitar de Mi lista',
    'common.addedToList': 'Añadido a Mi lista',
    'common.removedFromList': 'Eliminado de Mi lista',
    'common.hide': 'No me interesa',
    'common.hidden': 'Ocultado',
    'common.live': 'EN DIRECTO',
    'common.now': 'Ahora',
    'common.next': 'A continuación',
    'common.category': 'Categoría',
    'country.title': 'País',
    'country.none': 'Sin país',
    'country.n': '{n} países',
    'common.nCategories': '{n} categorías',
    'common.categories': 'Categorías',
    'common.sort': 'Ordenar',
    'common.sortWatched': "Último visto",
    'watched.badge': "Visto",
    'watched.markWatched': "Marcar como visto",
    'watched.markUnwatched': "Marcar como no visto",
    'watched.markSeasonWatched': "Marcar temporada como vista",
    'watched.markSeasonUnwatched': "Marcar temporada como no vista",
    'watched.toastWatched': "Marcado como visto",
    'watched.toastUnwatched': "Marcado como no visto",
    'home.recentlyAdded': "Añadido recientemente",
    'watched.filter': "Vistas",
    'watched.unseen': "Sin ver",
    'watched.seen': "Vistas",
    'watched.surprise': "Sorpréndeme",
    'watched.surpriseNone': "No hay nada que elegir con estos filtros",
    'promo.tv.title': "Tu TV.",
    'promo.tv.accent': "Tus reglas.",
    'promo.tv.text': "Organiza tus canales, películas y series en una sola aplicación. Rápida, sencilla y a tu medida.",
    'promo.tv.cta': "Ver TV en directo",
    'promo.tv.more': "Ver la guía",
    'promo.lib.title': "Añade tus",
    'promo.lib.accent': "películas y series.",
    'promo.lib.text': "Conecta tu fuente IPTV, Jellyfin, Emby o Plex y verás aquí tu catálogo con carátulas, tendencias y «Seguir viendo».",
    'promo.lib.cta': "Añadir fuente",
    'promo.guide.title': "Sabe qué ponen",
    'promo.guide.accent': "ahora y después.",
    'promo.guide.text': "Consulta la guía de programación de tus canales, marca tus favoritos y vuelve a ellos en un toque.",
    'promo.guide.cta': "Abrir la guía",
    'promo.b1': "Todas tus fuentes en un solo lugar",
    'promo.b2': "Interfaz moderna y fácil de usar",
    'promo.b3': "En todos tus dispositivos",
    'promo.b4': "Personaliza tu experiencia",
    'promo.f1': "TV en directo",
    'promo.f2': "Películas y series",
    'promo.f3': "Guía (EPG)",
    'promo.f4': "Grabaciones",
    'promo.f5': "Perfiles",
    'promo.ad': "Publicidad",
    'heroAdmin.title': "Cabecera del inicio",
    'heroAdmin.sub': "Diseña las pantallas del carrusel: textos, imagen de fondo, fechas y publicidad",
    'heroAdmin.help': "Las pantallas se enseñan en el inicio de quien solo tiene canales (sin películas ni series), en este orden. Los cambios llegan a las apps en pocos minutos.",
    'heroAdmin.new': "Nueva pantalla",
    'heroAdmin.useBuiltin': "Empezar con las de serie",
    'heroAdmin.empty': "Aún no hay pantallas tuyas: la app enseña las suyas de serie.",
    'heroAdmin.builtinAdded': "Pantallas de serie añadidas: ya puedes cambiarles la imagen y los textos",
    'heroAdmin.builtin': "de serie",
    'heroAdmin.on': "Activa",
    'heroAdmin.off': "Desactivada",
    'heroAdmin.from': "desde",
    'heroAdmin.until': "hasta",
    'heroAdmin.up': "Subir",
    'heroAdmin.down': "Bajar",
    'heroAdmin.toggle': "Activar o desactivar",
    'heroAdmin.edit': "Editar",
    'heroAdmin.remove': "Quitar",
    'heroAdmin.removeConfirm': "¿Quitar la pantalla «{name}» de la cabecera? La imagen se conserva en el servidor.",
    'heroAdmin.saved': "Guardado: las apps lo recogerán en unos minutos",
    'heroAdmin.fTitle': "Título",
    'heroAdmin.fAccent': "Parte destacada del título (en color)",
    'heroAdmin.fText': "Texto",
    'heroAdmin.fCtaLabel': "Botón principal: texto",
    'heroAdmin.fMoreLabel': "Botón secundario: texto",
    'heroAdmin.fCtaHref': "Botón principal: enlace",
    'heroAdmin.fMoreHref': "Botón secundario: enlace",
    'heroAdmin.fImage': "Imagen de fondo",
    'heroAdmin.fImageMobile': "Imagen para móvil (opcional)",
    'heroAdmin.noImage': "Sin imagen (dibujo de serie)",
    'heroAdmin.upload': "Subir imagen",
    'heroAdmin.uploading': "Subiendo…",
    'heroAdmin.uploaded': "Imagen subida",
    'heroAdmin.fFrom': "Se enseña desde",
    'heroAdmin.fUntil': "Se enseña hasta",
    'heroAdmin.fEnabled': "Activa",
    'heroAdmin.fAd': "Es publicidad (muestra la etiqueta «Publicidad»)",
    'heroAdmin.err.unauthorized': "Tu sesión ha caducado: entra otra vez",
    'heroAdmin.err.forbidden': "Solo los administradores pueden cambiar la cabecera",
    'heroAdmin.err.invalid': "Alguna pantalla no es válida",
    'heroAdmin.err.duplicate': "Hay dos pantallas con el mismo identificador",
    'heroAdmin.err.bad_slides': "Demasiadas pantallas o formato incorrecto",
    'heroAdmin.err.bad_json': "Datos incorrectos",
    'heroAdmin.err.too_large': "La imagen pesa demasiado (máximo 6 MB)",
    'heroAdmin.err.not_image': "Ese archivo no es una imagen válida (JPG, PNG, WebP, AVIF o GIF)",
    'heroAdmin.err.server': "No se ha podido guardar. Inténtalo de nuevo",
    'heroAdmin.err.empty': "Pon un título o una imagen",
    'heroAdmin.fShow': "Intercalar entre las películas y series destacadas (si no, solo se enseña cuando no hay películas ni series)",
    'heroAdmin.fDim': "Oscuridad del degradado sobre la imagen",
    'heroAdmin.fSideX': "Cuadro de ventajas: distancia desde la derecha",
    'heroAdmin.fTextX': "Texto: distancia desde la izquierda",
    'heroAdmin.fTextY': "Texto: altura",
    'heroAdmin.fTextW': "Texto: ancho",
    'heroAdmin.fTitleSize': "Tamaño del título",
    'heroAdmin.fTextSize': "Tamaño del texto",
    'heroAdmin.fSideY': "Cuadro de ventajas: altura",
    'heroAdmin.fSideSize': "Cuadro de ventajas: tamaño",
    'heroAdmin.layout': "Diseño",
    'heroAdmin.dragHint': "En la vista previa puedes arrastrar el bloque de texto y el cuadro de ventajas para colocarlos. En móvil el texto va siempre abajo.",
    'heroAdmin.features': "Funciones (iconos bajo el texto)",
    'heroAdmin.benefits': "Ventajas (cuadro de la derecha)",
    'heroAdmin.addRow': "Añadir",
    'heroAdmin.icon': "Icono",
    'heroAdmin.iconHelp': "El icono es un nombre de Material Icons: live_tv, bolt, devices, verified_user, tune…",
    'heroAdmin.tagAlways': "siempre",
    'common.filter': 'Filtrar',
    'common.refresh': 'Actualizar',
    'common.error': 'Error',
    'common.errorLoad': 'No se pudo cargar el contenido',
    'common.errorNetwork': 'Error de red. Comprueba la conexión o el proxy.',
    'common.offline': 'Sin conexión',
    'common.online': 'Conexión restablecida',
    'common.season': 'Temporada',
    'common.seasonShort': 'T',
    'common.episodeShort': 'E',
    'common.episodes': 'Episodios',
    'common.minutes': 'min',
    'common.year': 'Año',
    'common.director': 'Director',
    'common.composer': 'Música',
    'detail.spotify': 'Banda sonora en Spotify',
    'common.cast': 'Reparto',
    'common.genre': 'Género',
    'common.country': 'País',
    'common.duration': 'Duración',
    'common.rating': 'Valoración',
    'common.released': 'Estreno',
    'common.format': 'Formato',
    'common.channels': 'canales',
    'common.movies': 'películas',
    'common.series': 'series',
    'common.watched': 'visto',
    'common.moreOptions': 'Más opciones',
    'common.unlock': 'Desbloquear',
    'common.locked': 'Contenido bloqueado',

    'home.continue': 'Continuar viendo',
    'home.continueLive': 'Continuar en directo',
    'home.trending': 'Tendencias',
    'home.top10': 'Top 10 en Filoteca esta semana',
    'home.top10Trending': 'Top 10 de la semana: tendencias',
    'home.recommended': 'Recomendado para ti',
    'home.because': "Porque viste {title}",
    'home.removeContinue': 'Quitar de «Continuar viendo»',
    'home.removedContinue': 'Quitado de «Continuar viendo»',
    'home.mylist': 'Mi lista',
    'home.liveNow': 'En directo ahora',
    'home.recentChannels': 'Canales recientes',
    'home.newMovies': 'Películas añadidas recientemente',
    'home.newSeries': 'Series añadidas recientemente',
    'home.topRated': 'Mejor valoradas',
    'hero.prev': 'Destacado anterior',
    'hero.next': 'Siguiente destacado',
    'home.featured': 'Destacado',
    'home.newAdded': 'Novedad',
    'home.welcome': 'Bienvenido',
    'home.emptyTitle': 'Todavía no hay nada aquí',
    'home.emptyText': 'Explora la TV en directo, las películas y las series para empezar.',

    'live.title': 'TV en directo',
    'live.panelAll': 'Todos los canales',
    'live.panelNext': 'Después',
    'live.panelOrderHint': 'Pausa o ≡ sobre un canal o categoría: ordenar',
    'live.panelSearch': 'Buscar en categorías',
    'live.viewPanel': 'Panel con vista previa',
    'live.search': 'Buscar canales…',
    'live.scope': 'Mostrar',
    'live.nProviders': '{n} fuentes',
    'live.sortBy': 'Ordenar por',
    'live.sortDefault': 'Orden de la fuente',
    'sort.mine': "Mi orden",
    'sort.mineCats': "Mi orden de hileras",
    'sort.mineEdit': "Ordenar a mi gusto…",
    'order.title': "Ordenar hileras",
    'order.titleLive': "Ordenar hileras y canales",
    'order.hint': "Arrastra por el asa (⋮⋮) o usa las flechas ▲ ▼. Se guarda solo.",
    'order.hintLive': "Un canal suelto se mueve manteniendo pulsada su tarjeta.",
    'order.moveFirst': "Mover al principio",
    'order.moveLeft': "Mover a la izquierda",
    'order.moveRight': "Mover a la derecha",
    'order.moveLast': "Mover al final",
    'order.cantMove': "Ya está en ese extremo",
    'order.hintTv': "Pulsa OK en una fila para cogerla, muévela con ▲ ▼ y pulsa OK para soltarla. Se guarda solo.",
    'order.channels': "Canales",
    'order.back': "Volver",
    'order.reset': "Restablecer",
    'order.resetConfirm': "¿Volver al orden del proveedor? Se pierde el orden que has elegido.",
    'order.done': "Listo",
    'order.up': "Subir",
    'order.down': "Bajar",
    'live.viewGrid': 'Cuadrícula',
    'live.viewList': 'Lista',
    'live.viewStage': 'En pantalla',
    'live.nowOn': 'Ahora en emisión',
    'live.stageOpen': 'Pantalla completa',
    'live.stageError': 'No se puede reproducir este canal ahora.',
    'live.stageExit': 'Cambiar vista',
    'live.quality': 'Calidad',
    'live.favorites': 'Favoritos',
    'live.recent': 'Recientes',
    'live.guide': 'Guía',
    'live.noEpg': 'Sin información de programación',
    'live.nowOn': 'Ahora en emisión',
    'settings.channelListStyle': 'Lista de canales en el reproductor',
    'settings.channelListStyleSub': 'Panel lateral o una tira inferior con el canal enfocado y los demás en fila, con el directo de fondo',
    'settings.channelListPanel': 'Panel lateral',
    'settings.channelListStrip': 'Tira inferior',
    'live.watchFromStart': 'Ver desde el inicio',
    'live.startsAt': 'Empieza a las {time}',
    'live.lastDays': 'Últimos {n} días',
    'settings.liveInfoStyle': 'Información del directo',
    'settings.liveInfoStyleSub': 'Al pulsar «i» en un canal: la guía (programa en emisión, los siguientes y atajos) o solo la información sencilla',
    'settings.liveInfoGuide': 'Guía del canal',
    'settings.liveInfoSimple': 'Sencilla',
    'live.epgLoading': 'Descargando guía de programación…',
    'live.epgUpdated': 'Guía actualizada',
    'live.channelList': 'Canales',
    'live.catchup': 'Ver desde el inicio',
    'live.catchupOf': 'Emisión: {title}',
    'live.goLive': 'IR A DIRECTO',
    'live.prevChannel': 'Canal anterior',
    'live.nextChannel': 'Canal siguiente',
    'live.channelNumber': 'Canal {num}',

    'guide.title': 'Guía de TV',
    'guide.now': 'Ahora',
    'guide.earlier': 'Antes',
    'guide.later': 'Después',
    'guide.noData': 'Sin programación',
    'guide.watchChannel': 'Ver el canal',
    'guide.calendar': 'Calendario',
    'guide.scrub': 'Ir a otra hora',
    'guide.today': 'Hoy',
    'guide.tomorrow': 'Mañana',
    'guide.yesterday': 'Ayer',
    'guide.live': 'DIRECTO',
    'detail.kindMovie': 'Película',
    'detail.kindSeries': 'Serie',
    'detail.share': 'Compartir',
    'share.footer': "Compartido desde Filoteca",
    'share.trailer': "Tráiler",
    'share.watching': "Estoy viendo {name}",
    'share.seasons': "{n} temporada(s)",
    'share.noSheet': "Este navegador no tiene hoja de compartir del sistema.",
    'share.sheetFailed': "El navegador no abrió la hoja de compartir ({why}).",
    "dev.group": "Modo desarrollador",
    "dev.exportConfig": "Descargar configuración (JSON)",
    "dev.exportConfigSub": "Ajustes, vistas, filtros y orden de este aparato",
    "dev.exportConfigNote": "Sin claves ni datos personales. Se guarda como {name}.",
    "dev.copy": "Copiar",
    "dev.download": "Descargar archivo",
    "dev.share": "Compartir archivo",
    "dev.copied": "Configuración copiada",
    "dev.copyFailed": "No se pudo copiar",
    "dev.unlocked": "Modo desarrollador activado",
    "dev.left": "Faltan {n} pulsaciones",
    "dev.off": "Desactivar modo desarrollador",
    "dev.disabled": "Modo desarrollador desactivado",
    'share.via': "Compartir por…",
    'share.email': "Correo",
    'share.copy': "Copiar texto",
    'share.copied': "Texto copiado: pégalo donde quieras",
    'player.share': "Compartir",
    'detail.info': 'Información',
    'detail.moreInfo': 'Más información',
    'detail.similar': 'Más como esto',
    'settings.similarByTaste': 'Ordenar «Más como esto» según mis gustos',
    'settings.similarByTasteSub': 'Las películas y series de abajo de una ficha, por parecido a ella y a lo que has visto; si lo apagas, salen de su categoría',
    'detail.linkCopied': 'Enlace copiado',
    'detail.castMore': '+{n} más',
    'detail.castSeeMore': 'Ver más',
    'detail.watchOn': 'Ver en',
    'detail.rentBuy': 'Alquilar o comprar',
    'detail.justwatch': 'Disponibilidad: JustWatch',
    'detail.castLess': 'Menos',
    'detail.video': 'Vídeo',
    'detail.audio': 'Audio',
    'detail.compatAudio': 'El audio de este archivo (Dolby/DTS) no lo decodifica este dispositivo en el navegador: puede reproducirse sin sonido.',
    'detail.compatVideo': 'El vídeo de este archivo usa un códec que este dispositivo no decodifica en el navegador.',
    'detail.compatBoth': 'Ni el vídeo ni el audio de este archivo los decodifica este dispositivo en el navegador.',
    'detail.compatAudioFixed': 'El audio de este archivo (Dolby/DTS) se convierte en el servidor para que se oiga en este dispositivo.',
    'player.transcode': 'Convertir audio en el servidor',
    'settings.transcodeAudio': 'Audio Dolby/DTS',
    'settings.transcodeAudioSub': 'Convertir a AAC en el servidor cuando este dispositivo no lo decodifica',
    'settings.transcodeAlways': 'Siempre',
    'settings.transcodeNever': 'Nunca',
    'speed.button': 'Probar velocidad',
    'speed.title': 'Prueba de velocidad',
    'speed.testingServer': 'Midiendo proveedor → servidor…',
    'speed.testingDevice': 'Midiendo descarga en este dispositivo…',
    'speed.serverLeg': 'Proveedor → servidor',
    'speed.deviceLeg': 'Servidor → este dispositivo',
    'speed.directLeg': 'Proveedor → este dispositivo',
    'speed.needed': 'Necesario para esta película',
    'speed.unknown': 'sin datos',
    'speed.ok': 'Caudal suficiente. Si se corta, la causa no es la velocidad de descarga.',
    'speed.slowServer': 'El proveedor entrega los datos al servidor más despacio de lo que esta película necesita. Es el cuello de botella.',
    'speed.slowDevice': 'La conexión entre el servidor y este dispositivo no alcanza el caudal que esta película necesita.',
    'speed.slowDirect': 'El proveedor entrega los datos más despacio de lo que esta película necesita.',
    'speed.hint': 'Orientación: 1080p suele necesitar entre 5 y 12 Mb/s; 4K, más de 20 Mb/s.',
    'movies.title': 'Películas',
    'movies.search': 'Buscar películas…',
    'movies.sortName': 'Nombre',
    'movies.sortAdded': 'Recientes',
    'movies.sortRating': 'Valoración',
    'movies.sortYear': 'Año',
    'movies.trailer': 'Tráiler',

    'series.title': 'Series',
    'series.search': 'Buscar series…',
    'series.continue': 'Continuar T{season} E{episode}',
    'series.playFirst': 'Ver T1 E1',
    'series.nextEpisode': 'Siguiente episodio',
    'series.nextIn': 'Siguiente episodio en {seconds}s',
    'series.autoplayCancel': 'Cancelar',

    'search.title': 'Buscar',
    'search.placeholder': 'Canales, películas, series…',
    'search.hint': 'Escribe al menos 2 caracteres',
    'search.recent': 'Búsquedas recientes',
    'search.clearHistory': 'Borrar historial',
    'search.channels': 'Canales',
    'search.castHint': "Para buscar por actor o director hay que leer los repartos de las fichas.",
    'search.people': 'Personas',
    'actor.asDirector': 'Director en {n}',
    'actor.asActor': 'Actor en {n}',
    'search.movies': 'Películas',
    'search.series': 'Series',

    'player.audio': 'Audio',
    'player.subtitles': 'Subtítulos',
    'player.quality': 'Calidad',
    'player.retryTranscode': "Convirtiendo el audio para este dispositivo…",
    'settings.liveQuality': "Calidad en TV en directo",
    'settings.liveQualitySub': "Cuando el proveedor da el mismo canal en SD, HD y FHD",
    'settings.liveQualityAuto': "Automática (según la conexión)",
    'settings.liveQualityBest': "Siempre la mejor",
    'settings.liveQualitySaver': "Ahorro de datos",
    'player.variantDown': "Conexión justa: cambiado a {to}",
    'player.variantStart': "Conexión de {mbps} Mb/s: se abre en {to}",
    'player.variantAuto': "Automática",
    'player.netLine': "Conexión ~{mbps} Mb/s",
    'player.needLine': "este canal necesita ~{mbps} Mb/s",
    'player.speed': 'Velocidad',
    'player.fit': 'Ajuste de imagen',
    'player.fitContain': 'Ajustar',
    'player.fitCover': 'Rellenar',
    'player.pip': 'Imagen en imagen',
    'player.fullscreen': 'Pantalla completa',
    'player.fromDownload': 'Descargado en este dispositivo',
    'player.info': 'Información',
    'player.channels': 'Canales',
    'player.settings': 'Ajustes de reproducción',
    'player.errorTitle': 'No se puede reproducir',
    'player.errorNetwork': 'No se pudo conectar con el stream. Comprueba tu conexión o que la cuenta esté activa.',
    'player.errorMedia': 'El formato de este contenido no es compatible con este dispositivo.',
    'player.errorGeneric': 'Se produjo un error durante la reproducción.',
    'player.errorTimeout': 'La reproducción no ha empezado. Puede que el servidor del proveedor no responda, que la conexión sea lenta o que este dispositivo no decodifique el formato del canal.',
    'player.errorTranscodeBusy': 'El servidor está convirtiendo el audio de otras reproducciones y no tiene hueco ahora mismo. Inténtalo en unos minutos.',
    'player.errorTranscodeAuth': 'La sesión ha caducado. Vuelve a iniciar sesión para convertir el audio en el servidor.',
    'player.errorTranscode': 'El servidor no ha podido convertir el audio de este archivo.',
    'player.backToPlayer': 'Volver al reproductor',
    'player.stats': 'Estadísticas de reproducción',
    'player.retrying': 'Reconectando…',
    'player.off': 'Desactivados',
    'player.trackDefault': 'Pista {n}',
    'player.keysHint': 'OK: pausa · ◀ ▶: buscar · ▲ ▼: canal · Atrás: salir',

    'login.title': 'Conecta tu contenido',
    'login.subtitle': 'Añade contenido en abierto, tu biblioteca o archivos de red. Todo se guarda solo en este dispositivo.',
    'login.typeXtream': 'Xtream Codes',
    'login.typeM3u': 'Lista M3U',
    'login.name': 'Nombre de la fuente',
    'login.namePh': 'Ej. Casa',
    'login.host': 'Servidor (URL)',
    'login.hostPh': 'http://servidor.com:8080',
    'login.user': 'Usuario',
    'login.pass': 'Contraseña',
    'login.m3u': 'URL de la lista M3U',
    'login.m3uPh': 'http://…/lista.m3u  ·  o la IP de tu HDHomeRun / TVHeadend',
    'login.epg': 'URL de la guía EPG (XMLTV, opcional)',
    'login.connect': 'Conectar',
    'login.connecting': 'Conectando…',
    'login.errorFields': 'Rellena todos los campos obligatorios.',
    'login.errorAuth': 'Usuario o contraseña incorrectos, o cuenta inactiva.',
    'login.errorHost': 'No se pudo conectar con el servidor. Revisa la URL o activa el proxy en Ajustes.',
    'login.errorM3u': 'No se pudo leer la lista M3U.',
    'login.success': 'Conectado correctamente',
    'login.demo': 'Probar con demo',
    'login.googleTitle': 'Entra en Filoteca',
    'login.googleSubtitle': 'Usa tu cuenta de Google. Tus fuentes quedan guardadas en tu cuenta y disponibles en todos tus dispositivos.',
    'login.googleLoading': 'Cargando Google…',
    'login.googleError': 'No se pudo iniciar sesión con Google. Inténtalo de nuevo.',
    'login.notAllowed': 'Tu cuenta de Google no está autorizada en Filoteca. Contacta con el administrador.',
    'login.pairQrHint': 'Escanea este código QR con la cámara del móvil…',
    'login.pairTitle': 'Vincular este dispositivo',
    'login.pairHint': 'En tu móvil u ordenador, con la sesión iniciada, entra en {url} y escribe este código:',
    'login.pairWaiting': 'Esperando confirmación…',
    'login.pairExpired': 'El código ha caducado.',
    'login.pairNew': 'Nuevo código',
    'login.pairShow': '¿Estás en una TV? Vincular con un código',
    'login.hello': 'Hola, {name}',
    'login.addProviderSub': 'Tu propia biblioteca, tus carpetas o canales en abierto. Los datos se guardan cifrados en tu cuenta y estarán en todos tus dispositivos.',
    'login.signOut': 'Salir de la cuenta',
    'login.serverUrl': 'Servidor: {url}',

    'pair.title': 'Vincular una TV',
    'pair.hint': 'Escribe el código de 6 caracteres que muestra la TV u otro dispositivo.',
    'pair.button': 'Vincular',
    'pair.success': 'Dispositivo vinculado. Ya puedes usarlo.',
    'pair.error': 'Código incorrecto o caducado.',

    'admin.title': 'Usuarios autorizados',
    'admin.addUser': 'Añadir usuario',
    'admin.emailPh': 'correo@gmail.com',
    'admin.roleAdmin': 'Administrador',
    'admin.roleUser': 'Usuario',
    'admin.active': 'Activo',
    'admin.inactive': 'Desactivado',
    'admin.remove': 'Eliminar usuario',
    'admin.removeConfirm': '¿Eliminar a {email} y sus fuentes guardadas?',
    'admin.never': 'Nunca ha entrado',
    'admin.lastLogin': 'Último acceso: {date}',
    'admin.added': 'Usuario añadido',
    'admin.invalidEmail': 'Correo no válido',
    'admin.makeAdmin': 'Hacer administrador',
    'admin.makeUser': 'Quitar administrador',
    'admin.disable': 'Desactivar acceso',
    'admin.enable': 'Activar acceso',
    'login.invite.ok': 'Te han invitado a Filoteca. Crea tu cuenta con tu correo o con Google.',
    'login.invite.bad': 'Esta invitación no es válida o ya ha caducado. Pídele otra a quien te la envió.',
    'admin.invites': 'Invitaciones',
    'admin.inviteNew': 'Crear invitación',
    'admin.inviteHelp': 'Un enlace para que alguien se cree su propia cuenta sin que tengas que escribir su correo.',
    'admin.inviteEmpty': 'Aún no has creado ninguna invitación.',
    'admin.inviteTitle': 'Nueva invitación',
    'admin.inviteValid': 'Válida durante',
    'admin.inviteDays': '{n} días',
    'admin.inviteDay1': '1 día',
    'admin.inviteUses': 'Personas que pueden usarla',
    'admin.inviteUses1': 'Solo 1 persona',
    'admin.inviteUsesN': '{n} personas',
    'admin.inviteNote': 'Para quién es (opcional)',
    'admin.inviteCreate': 'Crear enlace',
    'admin.inviteLinkTitle': 'Enlace de invitación',
    'admin.inviteLinkHelp': 'Cópialo ahora: por seguridad no se vuelve a mostrar.',
    'admin.inviteCopy': 'Copiar',
    'admin.inviteShare': 'Compartir',
    'admin.inviteCopied': 'Enlace copiado',
    'admin.inviteRevoke': 'Revocar invitación',
    'admin.inviteRevokeConfirm': 'El enlace dejará de funcionar. Quien ya se haya registrado con él conserva su cuenta.',
    'admin.inviteRevoked': 'Invitación revocada',
    'admin.inviteUnnamed': 'Invitación {id}',
    'admin.inviteStatus.active': 'Activa',
    'admin.inviteStatus.used': 'Agotada',
    'admin.inviteStatus.expired': 'Caducada',
    'admin.inviteStatus.revoked': 'Revocada',
    'admin.inviteUsage': '{uses} de {max} usos · caduca {date}',
    'admin.inviteShareText': 'Te invito a Filoteca. Crea tu cuenta aquí:',

    'settings.title': 'Ajustes',
    'settings.profiles': 'Fuentes',
    'settings.currentProfile': 'Fuente activa',
    'settings.addProfile': 'Añadir fuente',
    'settings.switchProfile': 'Cambiar de fuente',
    'settings.editProfile': 'Editar fuente',
    'settings.deleteProfile': 'Eliminar fuente',
    'settings.deleteProfileConfirm': '¿Eliminar la fuente "{name}" y sus datos guardados?',
    'settings.account': 'Cuenta',
    'settings.accountStatus': 'Estado',
    'settings.accountExpires': 'Caduca',
    'settings.accountConnections': 'Conexiones',
    'settings.accountNever': 'Sin caducidad',
    'settings.server': 'Servidor',
    'settings.appearance': 'Apariencia',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.themeDark': 'Oscuro',
    'settings.themeLight': 'Claro',
    'settings.themeAuto': 'Según el sistema',
    'settings.intro': "Animación de inicio",
    'settings.introSub': "El logo se enciende al abrir la app; se salta con un toque",
    'settings.introSubWeb': "Al abrir Filoteca (una vez por sesión); se salta con un toque",
    'settings.introSound': "Sonido de la animación",
    'settings.introPlay': "Ver la animación",
    'welcome.skip': 'Saltar',
    'welcome.back': 'Atrás',
    'welcome.next': 'Siguiente',
    'welcome.start': 'Empezar',
    'welcome.enter': 'Entrar en Filoteca',
    'welcome.step': 'Paso {n} de {total}',
    'welcome.1a': 'Tu contenido,',
    'welcome.1b': 'organizado a tu manera.',
    'welcome.1text': 'Canales en abierto, películas, series y tus propias fuentes, todo en un solo lugar.',
    'welcome.2a': 'Todo en un',
    'welcome.2b': 'mismo lugar',
    'welcome.2text': 'Disfruta de tus películas, series y canales en una biblioteca moderna y organizada.',
    'welcome.3a': 'Añade',
    'welcome.3b': 'tus fuentes',
    'welcome.3text': 'Conecta tus propias bibliotecas, servidores y fuentes compatibles. Filoteca las organiza para que disfrutes de todo desde un mismo lugar.',
    'welcome.4a': 'Hecho para',
    'welcome.4b': 'el sofá',
    'welcome.4text': 'Navega con el mando de la tele, usa el móvil como mando con un código QR y sigue viendo en cualquier aparato.',
    'welcome.5a': 'Todo',
    'welcome.5b': 'listo',
    'welcome.5text': 'Añade tu primera fuente y empieza a ver. Puedes cambiar lo que quieras en Ajustes.',
    'welcome.icFavorites': 'Favoritos',
    'welcome.icIptv': 'Listas',
    'welcome.icServers': 'Servidores multimedia',
    'welcome.icFolders': 'Carpetas de red',
    'welcome.icHub': 'Filoteca Hub',
    'welcome.icRemote': 'Mando de la tele',
    'welcome.icQr': 'Móvil como mando',
    'welcome.icDevices': 'Móvil y tablet',
    'welcome.icSync': 'Sincronizado',
    'welcome.icReady': 'Listo',
    'settings.welcome': 'Ver la introducción',
    'settings.welcomeSub': 'El recorrido de la primera vez, en cinco pantallas',
    'coach.ok': "Entendido",
    'coach.viewers': "Toca tu foto para cambiar de espectador o abrir el menú. Cada espectador tiene su propia lista y su progreso.",
    'coach.search': "Escribe un título, un canal o el nombre de un actor: se busca en canales, películas y series a la vez.",
    'coach.filters': "Filtra por país, fuente, categoría o lo que todavía no has visto, y ordena como prefieras.",
    'coach.fav': "Pulsa aquí para guardarlo en Mi lista y encontrarlo después con un toque.",
    'coach.tvHold': "Mantén pulsado OK sobre un canal, una película o una serie para añadirlo a Mi lista y ver más opciones.",
    'settings.coach': "Ayudas en pantalla",
    'settings.coachSub': "Pequeños consejos, una sola vez en cada pantalla",
    'settings.coachReset': "Ver las ayudas otra vez",
    'settings.coachResetDone': "Las ayudas volverán a aparecer",
    'settings.tvMode': 'Modo TV (10 pies)',
    'settings.tvModeSub': 'Interfaz grande y navegación con mando',
    'settings.skin': 'Color de la interfaz',
    'settings.shell': 'Aspecto',
    'settings.shellSub': 'Pieles completas: colores, letra y formas. «Cine» es el diseño original.',
    'shell.cine': 'Cine',
    'shell.cine.desc': 'El diseño original, oscuro o claro según el tema.',
    'shell.papel': 'Papel',
    'shell.papel.desc': 'Crema, letra con serifa y carátulas con marco: una biblioteca.',
    'shell.terminal': 'Terminal',
    'shell.terminal.desc': 'Negro, monoespaciada, filetes y nada de sombras. Denso.',
    'shell.pastel': 'Pastel',
    'shell.pastel.desc': 'Claro, muy redondeado, carátulas cuadradas con aire.',
    'shell.retro': 'Retro TV',
    'shell.retro.desc': 'Azul profundo, letra condensada y ámbar, al estilo teletexto.',
    'shell.consola': 'Consola',
    'shell.consola.desc': 'Grafito y verde ácido, dock flotante, cabecera partida y carátulas apaisadas con rebote: una consola.',
    'shell.mosaico': 'Mosaico',
    'shell.mosaico.desc': 'Berenjena y mandarina, sin cabecera, filas en cuadrícula y carátulas cuadradas muy redondeadas: una galería.',
    'shell.catalogo': 'Catálogo',
    'shell.catalogo.desc': 'Gris de laboratorio y verde botella, letra de máquina, banda baja y renglones: una ficha de biblioteca.',
    'shell.aurora': 'Aurora',
    'shell.aurora.desc': 'Violeta profundo con resplandores rosas, carátulas y canales redondos y entrada con rebote: una noche con luces.',
    'shell.escenario': 'Escenario',
    'shell.escenario.desc': 'Un teatro a oscuras: lo que miras enciende el fondo de toda la pantalla con su propia imagen y deja al resto en penumbra. Latón sobre negro, titulares con serifa y luces de escena.',
    'shell.escenario-dia': 'Escenario de día',
    'shell.escenario-dia.desc': 'La sesión de tarde: el mismo foco de sala sobre papel marfil. Lo que miras tiñe el fondo como una acuarela y el resto se apaga. Bronce, tinta cálida y titulares con serifa.',
    'shell.quiosco-noche': 'Quiosco noche',
    'shell.quiosco-noche.desc': 'La misma revista impresa en negro: tinta cálida, texto crema, carril lateral y carátulas apaisadas con marco.',
    'shell.noir': 'Noir',
    'shell.noir.desc': 'Blanco y negro con plata, titulares con serifa fina, cabecera en banda, ficha con la imagen arriba, grano de película y entradas en fundido: cine negro.',
    'shell.quiosco': 'Quiosco',
    'shell.quiosco.desc': 'Papel crema, titulares con serifa, menú en un carril lateral y carátulas apaisadas con marco: una revista.',
    'shell.custom': 'propio',
    'shell.previewTitle': 'Continuar viendo',
    'shell.import': 'Importar shell',
    'shell.importHelp': 'Pega aquí el JSON de un shell (id, nombre, base, variables y formas). Solo se aceptan las variables de diseño conocidas; nada de código.',
    'shell.importDo': 'Importar',
    'shell.imported': 'Shell «{name}» añadido y aplicado',
    'shell.invalid': 'Ese shell no vale: necesita un id (letras y guiones), y variables o formas conocidas.',
    'shell.badJson': 'Eso no es un JSON válido.',
    'shell.export': 'Copiar el actual',
    'shell.exported': 'Shell copiado al portapapeles',
    'shell.remove': 'Borrar shell',
    'shell.removeConfirm': '¿Borrar el shell «{name}»?',
    'settings.skinSub': 'Color de acento de botones, marcadores y resaltados',
    'skin.default': 'Original (rojo)',
    'skin.ocean': 'Océano (azul)',
    'skin.emerald': 'Esmeralda (verde)',
    'skin.amethyst': 'Amatista (morado)',
    'skin.amber': 'Ámbar (naranja)',
    'skin.rose': 'Rosa',
    'actor.title': 'Reparto',
    'actor.with': 'Películas y series con {name}',
    'actor.results': '{count} títulos',
    'actor.emptyTitle': 'Todavía no hay títulos con este nombre',
    'actor.emptyText': 'Solo se conocen los repartos de las fichas ya abiertas. Busca en todo el catálogo para completarlo.',
    'actor.hint': 'Los repartos se conocen al abrir cada ficha. Puedes buscar en todo el catálogo para encontrar más.',
    'actor.searching': "Buscando su filmografía…",
    'actor.fromTmdb': "Filmografía de TMDB cruzada con tu catálogo.",
    'actor.scan': 'Buscar en todo el catálogo',
    'actor.scanning': 'Buscando en el catálogo… {done} de {total}',
    'actor.scanDone': 'Búsqueda completada',
    'actor.stop': 'Detener',
    'age.tp': 'TP',
    'age.blockedTitle': 'No disponible en este perfil',
    'age.blockedText': 'Este título está clasificado {label} y el perfil «{viewer}» solo permite hasta {max} años.',
    'age.blockedToast': 'No disponible para este perfil por su clasificación por edades ({label})',
    'who.maxAge': 'Edad máxima',
    'who.maxAgeSub': 'Oculta o bloquea los títulos clasificados por encima de esta edad',
    'who.maxAgeAny': 'Sin límite',
    'settings.uiScale': 'Tamaño de la interfaz',
    'settings.navFade': "Transparencia del menú",
    'settings.navFadeSub': "Del menú superior sobre la cabecera de Inicio: 0 % barra oscura, 100 % totalmente transparente",
    'settings.playback': 'Reproducción',
    'settings.autoplayNext': 'Reproducir siguiente episodio',
    'settings.nextOffer': 'Aviso de siguiente episodio',
    'settings.nextOfferSub': 'Cuánto antes del final sale el botón «Siguiente episodio»',
    'settings.nextOfferMin': '{n} min antes',
    'settings.nextOfferOff': 'Solo al terminar',
    'settings.autoplayPreview': 'Vista previa en las carátulas',
    'settings.autoplayPreviewSub': 'Reproduce unos segundos sin sonido al abrir una ficha',
    'settings.peekCard': 'Tarjeta ampliada',
    'settings.peekCardSub': 'Al dejar el ratón (o el mando) sobre una carátula, muestra la ficha resumida sin abrirla',
    'settings.libraryHero': 'Cabecera destacada',
    'settings.libraryHeroSub': 'Un carrusel con títulos destacados arriba de Películas y de Series (sin búsqueda ni filtros)',
    'settings.libraryBarOverlay': 'Barra sobre la cabecera',
    'settings.libraryBarOverlaySub': 'El título, la búsqueda y los filtros van superpuestos a la imagen destacada en Películas y Series',
    'settings.homeFilters': 'Inicio con mis filtros',
    'settings.homeFiltersSub': 'El Inicio solo enseña lo que dejan pasar tus filtros de TV en directo, Películas y Series (fuente, país, categorías y calidad)',
    'settings.top10': 'Fila «Top 10» del Inicio',
    'settings.top10Sub': 'De dónde sale el ranking: lo más visto en este servidor (necesita cuenta; si aún faltan datos se completa con tendencias), las tendencias de TMDB, o ninguno.',
    'settings.top10_own': 'Lo más visto aquí',
    'settings.top10_trending': 'Tendencias (TMDB)',
    'settings.top10_off': 'Oculto',
    'settings.compactLiveRow': 'Canales del Inicio más pequeños',
    'settings.compactLiveRowSub': 'Las tarjetas de «Continuar en directo» ocupan algo menos (un 80 %)',
    'settings.catalogAt': 'Catálogo actualizado: {date}',
    'settings.catalogAuto': 'Actualizar el catálogo cada día',
    'settings.catalogAutoSub': 'Con la app abierta (la tele encendida, el ordenador con Filoteca abierto), se actualiza solo cada 24 horas, nunca mientras ves algo. Con la app cerrada no puede',
    'settings.providerPartial': 'No se pudieron cargar: {what}. La fuente no contestó; se reintenta sola.',
    'access.title': 'Solicitudes de acceso',
    'access.sub': 'Quién pide tus fuentes y qué has concedido',
    'access.pendingN': '{n} pendiente(s) de respuesta',
    'access.help': 'Una app de Android o Windows pide acceso a tus fuentes. Comprueba que el código coincide con el que enseña esa app y elige qué concedes. No verán tus credenciales en pantalla.',
    'access.empty': 'No hay solicitudes',
    'access.code': 'Código {code}',
    'access.pendingSub': 'Caduca en {h} h',
    'access.accept': 'Aceptar…',
    'access.reject': 'Rechazar',
    'access.granted': 'Concedido',
    'access.revoke': 'Retirar acceso',
    'access.revokeConfirm': 'Esa app dejará de poder usar las fuentes que le diste en cuanto vuelva a comprobarlas.',
    'access.revoked': 'Acceso retirado',
    'access.chooseHelp': '«{label}» pide acceso (código {code}). Marca las fuentes que le concedes.',
    'access.noProviders': 'No tienes fuentes que se puedan compartir (Xtream, M3U, Jellyfin, Emby o Plex).',
    'access.grant': 'Conceder los marcados',
    'access.pickOne': 'Marca al menos una fuente.',
    'access.expired': 'La solicitud ya caducó o se resolvió.',
    'request.menu': 'Pedir una fuente a un usuario',
    'request.menuSub': 'Por su correo; la otra persona acepta desde la web',
    'request.emailHint': 'Correo del usuario de Filoteca que tiene la fuente',
    'request.sent': 'Petición enviada. Código de comprobación: {code}',
    'request.waiting': 'Esperando respuesta de {email}',
    'request.waitingSub': 'Código {code} · caduca en {h} h',
    'request.statusTitle': 'Solicitud pendiente',
    'request.statusBody': 'Has pedido acceso a {email}. Dile que compruebe que el código es {code}. En cuanto lo acepte, las fuentes aparecerán aquí.',
    'request.check': 'Comprobar ahora',
    'request.cancel': 'Cancelar petición',
    'request.accepted': '{n} fuente(s) añadida(s), compartidas por {who}',
    'request.rejected': 'Han rechazado tu petición.',
    'request.expired': 'La petición caducó sin respuesta.',
    'request.revoked': 'Te han retirado el acceso.',
    'request.badEmail': 'Escribe un correo válido.',
    'request.tooMany': 'Demasiadas peticiones. Espera un poco.',
    'settings.liveOk': 'Al pulsar OK en el directo',
    'settings.liveOkSub': 'Con los controles ocultos, OK abre la lista de canales sin parar la emisión; para pausar se usa su botón',
    'settings.liveOkChannels': 'Abrir la lista de canales',
    'settings.liveOkPause': 'Pausar',
    'settings.uiSounds': 'Sonidos de navegación',
    'settings.uiSoundsSub': 'Un tic al mover el foco, un clic al elegir, un tono al cerrar o volver y otro al cambiar de canal o abrir una película',
    'settings.uiSoundsAuto': 'Automático (solo en la tele)',
    'settings.uiSoundsOn': 'Siempre',
    'settings.uiSoundsOff': 'No',
    'settings.factoryReset': 'Restablecer la app',
    'settings.factoryResetSub': 'Borra fuentes, favoritos, ajustes y descargas de este aparato. Conserva tu licencia',
    'settings.factoryResetConfirm': '¿Restablecer Filoteca en este aparato? Se borrarán fuentes, favoritos, progreso, espectadores, ajustes, descargas y caché, y volverás a la bienvenida. Se conserva la licencia. No se puede deshacer.',
    'settings.factoryResetAccount': 'También se cerrará tu sesión; lo guardado en tu cuenta no se borra.',
    'settings.contentNotice': 'Aviso sobre el contenido',
    'settings.contentNoticeSub': 'Filoteca no aloja ni vende contenido: las listas de canales son de terceros y el contenido pertenece a quien lo emite. Si eres titular de derechos y quieres que se retire un canal, usa la opción de denuncia de esta misma pantalla.',
    'settings.creditsNotice': 'Filoteca no aloja ni vende contenido: las listas de canales son de terceros y el contenido pertenece a quien lo emite. Si eres titular de derechos y quieres que se retire un canal, usa el botón «Denunciar contenido» de abajo.',
    'settings.credits': 'Créditos de las listas',
    'settings.creditsSub': 'Canales públicos: iptv-org (github.com/iptv-org/iptv, dominio público) y TDTChannels (tdtchannels.com). Cine clásico: Internet Archive (archive.org).',
    'creditRole.channels': 'Listas de canales públicos por país',
    'creditRole.tdt': 'TDT en abierto de España, TV y radio con guía',
    'creditRole.archive': 'Cine clásico de dominio público',
    'creditRole.tmdb': 'Fichas, carátulas y reparto de películas y series',
    'creditRole.subs': 'Subtítulos',
    'settings.licensesAdmin': 'Licencias',
    'settings.licensesAdminSub': 'Claves, aparatos y plazas libres',
    'licAdmin.title': 'Licencias',
    'licAdmin.help': 'Claves de Filoteca y los aparatos que las usan. Libera un aparato para dejar una plaza libre, o sube las plazas de una clave.',
    'licAdmin.new': 'Nueva licencia',
    'licAdmin.newEmail': 'Correo de la persona',
    'licAdmin.newSeats': 'Plazas (aparatos que admite)',
    'licAdmin.created': 'Licencia creada',
    'licAdmin.badEmail': 'Ese correo no es válido.',
    'licAdmin.seats': '{used} de {max} aparatos',
    'licAdmin.full': 'sin plazas libres',
    'licAdmin.noDevices': 'Ningún aparato activado',
    'licAdmin.seen': 'visto {date}',
    'licAdmin.idle': 'sin uso hace {n} días',
    'licAdmin.free': 'Liberar',
    'licAdmin.freeConfirm': '¿Liberar «{name}»? Dejará de funcionar con esta clave y su plaza queda libre.',
    'licAdmin.freed': 'Plaza liberada',
    'licAdmin.freeAll': 'Liberar todos los aparatos',
    'licAdmin.freeAllConfirm': 'Se liberan todas las plazas de esta clave y sus aparatos dejarán de estar activados.',
    'licAdmin.setSeats': 'Cambiar plazas',
    'licAdmin.seatsPrompt': 'Plazas de esta clave (1 a 50)',
    'licAdmin.copy': 'Copiar clave',
    'licAdmin.copied': 'Clave copiada',
    'licAdmin.resend': 'Reenviar por correo',
    'licAdmin.resent': 'Enviada a {email}',
    'licAdmin.resendFail': 'No se pudo enviar el correo.',
    'licAdmin.revoke': 'Revocar clave',
    'licAdmin.revokeConfirm': 'La clave dejará de valer en todos sus aparatos en su próxima renovación (unos días como máximo). ¿Revocar?',
    'licAdmin.status.active': 'Activa',
    'licAdmin.status.revoked': 'Revocada',
    'licAdmin.status.expired': 'Caducada',
    'licAdmin.showRevoked': 'Ver revocadas ({n})',
    'licAdmin.hideRevoked': 'Ocultar revocadas',
    'licAdmin.empty': 'No hay licencias',
    'licAdmin.search': 'Buscar por correo, clave, nota o aparato',
    'licAdmin.chipActive': 'Activas ({n})',
    'licAdmin.chipRevoked': 'Revocadas ({n})',
    'licAdmin.chipAll': 'Todas ({n})',
    'licAdmin.chipFull': 'Sin plazas ({n})',
    'licAdmin.chipIdle': 'Con aparatos inactivos ({n})',
    'licAdmin.trial.title': 'Prueba gratuita de Premium',
    'licAdmin.trial.plan': 'Prueba',
    'licAdmin.trial.until': '{days} días · hasta {date}',
    'licAdmin.trial.unclaimed': 'sin activar · plazo hasta {date}',
    'licAdmin.trial.chip': 'Pruebas ({n})',
    'licAdmin.trial.left': 'Campaña de lanzamiento: {days} días · quedan {n} plazas',
    'licAdmin.trial.requested': 'Pedidas',
    'licAdmin.trial.given': 'Concedidas',
    'licAdmin.trial.activated': 'Activadas',
    'licAdmin.trial.inUse': 'En uso (7 días)',
    'licAdmin.trial.ofActive': 'de {n} en curso',
    'licAdmin.trial.ended': 'Terminadas',
    'licAdmin.trial.bought': 'Compraron después',
    'licAdmin.trial.chart': 'Últimos {n} días',
    'licAdmin.trial.export': 'Descargar correos con consentimiento ({n})',
    'licAdmin.beta.title': 'Beta gratuita',
    'licAdmin.beta.sourceAdmin': 'Ajustes guardados desde aquí (mandan sobre el servidor)',
    'licAdmin.beta.sourceEnv': 'Valores de la configuración del servidor',
    'licAdmin.beta.on': 'Encendida',
    'licAdmin.beta.off': 'Apagada',
    'licAdmin.beta.nowOn': 'Beta encendida: ya se puede pedir en /try',
    'licAdmin.beta.nowOff': 'Beta apagada: no se dan más; las concedidas siguen',
    'licAdmin.beta.days': '{n} días',
    'licAdmin.beta.daysPrompt': 'Días que recibe quien la pida a partir de ahora',
    'licAdmin.beta.inviteOnly': 'Solo con invitación',
    'licAdmin.beta.open': 'Abierta a cualquiera',
    'licAdmin.beta.extendAll': 'Prorrogar todas',
    'licAdmin.beta.extendOne': 'Prorrogar esta beta',
    'licAdmin.beta.extendPrompt': '¿Cuántos días más? Se avisa a cada persona por correo.',
    'licAdmin.beta.extended': 'Prorrogadas {n} betas',
    'licAdmin.beta.extendedOne': 'Prorrogada {n} días',
    'licAdmin.beta.newInvites': 'Crear invitaciones',
    'licAdmin.beta.devCode': 'Código de desarrollador',
    'licAdmin.beta.devCodeText': 'Código de un solo uso para activar el modo desarrollador en una app: {code}. Caduca en {min} minutos.',
    'licAdmin.beta.invitesPrompt': '¿Cuántas? (un uso cada una; se copian al portapapeles)',
    'licAdmin.beta.invitesMade': '{n} invitaciones creadas y copiadas',
    'licAdmin.beta.usesLeft': '{n} usos',
    'licAdmin.beta.useOne': '1 uso',
    'licAdmin.beta.tmdbOn': 'TMDB de Filoteca: encendido',
    'licAdmin.beta.tmdbOff': 'TMDB de Filoteca: apagado',
    'licAdmin.beta.tmdbNowOn': 'Las apps con licencia ya usan la clave de TMDB del servidor',
    'licAdmin.beta.tmdbNowOff': 'Las apps con licencia ya no usan la clave de TMDB del servidor',
    'licAdmin.beta.purchaseOn': "Venta de licencias: encendida",
    'licAdmin.beta.purchaseOff': "Venta de licencias: apagada",
    'licAdmin.beta.purchaseNowOn': "Ya se pueden comprar licencias",
    'licAdmin.beta.purchaseNowOff': "Ya no se venden licencias: la compra queda oculta",
    'licAdmin.store.title': 'Aparatos de tienda',
    'licAdmin.store.note': 'Versiones sin licencia (Amazon): cada aparato se registra solo al abrir la app, sin clave ni cuenta. Revocar uno solo le quita TMDB; la app le sigue funcionando.',
    'licAdmin.store.on': 'Registro: encendido',
    'licAdmin.store.off': 'Registro: apagado',
    'licAdmin.store.nowOn': 'Los aparatos de tienda ya se registran y usan TMDB',
    'licAdmin.store.nowOff': 'Registro apagado: ningún aparato de tienda se da de alta ni usa TMDB',
    'licAdmin.store.show': 'Ver aparatos',
    'licAdmin.store.hide': 'Ocultar aparatos',
    'licAdmin.store.search': 'Buscar por aparato, versión o identificador',
    'licAdmin.store.none': 'Ningún aparato',
    'licAdmin.store.total': 'Registrados',
    'licAdmin.store.active': 'Activos',
    'licAdmin.store.activeDays': 'vistos en {n} días',
    'licAdmin.store.week': 'Nuevos esta semana',
    'licAdmin.store.revokedCount': 'Revocados',
    'licAdmin.store.revoke': 'Revocar',
    'licAdmin.store.restore': 'Restaurar',
    'licAdmin.store.revoked': 'revocado el {date}',
    'licAdmin.store.revokeConfirm': '¿Quitar TMDB a este aparato? La app le seguirá funcionando; lo nota en su próxima renovación (unos días).',
    'licAdmin.store.revokedToast': 'Aparato revocado',
    'licAdmin.store.restoredToast': 'Aparato restaurado',
    'licAdmin.store.status.all': 'Todos',
    'licAdmin.store.status.active': 'Solo activos',
    'licAdmin.store.status.revoked': 'Solo revocados',
    'licAdmin.store.purch.title': 'Compras en la tienda (Amazon)',
    'licAdmin.store.purch.note': 'Premium comprado en el Amazon Appstore (gratis durante la beta). Cada compra va con una cuenta de Amazon (aquí solo un identificador) y vale en hasta {max} aparatos. Revocar una compra le quita Premium a todos sus aparatos en su próxima renovación.',
    'licAdmin.store.purch.total': 'Compras',
    'licAdmin.store.purch.users': 'Cuentas',
    'licAdmin.store.purch.devicesCount': 'Aparatos',
    'licAdmin.store.purch.week': 'Nuevas esta semana',
    'licAdmin.store.purch.canceledCount': 'Canceladas o revocadas',
    'licAdmin.store.purch.user': 'Cuenta {id}',
    'licAdmin.store.purch.devices': '{n} aparatos',
    'licAdmin.store.purch.test': 'de prueba',
    'licAdmin.store.purch.canceled': 'cancelada por Amazon el {date}',
    'licAdmin.store.purch.none': 'Ninguna compra',
    'licAdmin.store.purch.show': 'Ver compras',
    'licAdmin.store.purch.hide': 'Ocultar compras',
    'licAdmin.store.purch.revokeConfirm': '¿Quitar Premium a esta compra? Todos sus aparatos lo pierden en su próxima renovación (unos días).',
    'licAdmin.store.purch.revokedToast': 'Compra revocada',
    'licAdmin.store.purch.restoredToast': 'Compra restaurada',
    'licAdmin.mail.title': "Correos enviados",
    'licAdmin.mail.stats': "{total} enviados · {failed} fallidos · {day} en 24 h",
    'licAdmin.mail.show': "Ver historial",
    'licAdmin.mail.hide': "Ocultar",
    'licAdmin.mail.note': "Lo que el servidor envía (códigos, claves, respuestas de soporte, avisos): destinatario, asunto, fecha y resultado, nunca el contenido. Lo que llega a soporte@, abuse@… está en el webmail.",
    'licAdmin.mail.search': "Buscar por correo o asunto",
    'licAdmin.mail.all': "Todos",
    'licAdmin.mail.onlyFailed': "Solo fallidos",
    'licAdmin.mail.webmail': "Abrir el webmail",
    'licAdmin.mail.empty': "No hay correos con ese filtro.",
    'licAdmin.mail.more': "Ver más",
    'licAdmin.mail.failed': "No se pudo enviar",
    'licAdmin.mail.keep': "Se conservan los últimos {n} días.",
    'licAdmin.beta.revoke': 'Anular esta invitación',
    'licAdmin.beta.noteEnd': 'Sin tarjeta, sin renovación y sin cobro: al terminar, cada persona decide si compra.',
    'licAdmin.sortRecent': 'Orden: recientes',
    'licAdmin.sortEmail': 'Orden: correo',
    'licAdmin.sortSeats': 'Orden: más llenas',
    'licAdmin.found': '{n} licencias · mostrando {shown}',
    'licAdmin.more': 'Cargar más',
    'settings.paymentsAdmin': 'Pagos (Stripe)',
    'settings.paymentsAdminSub': 'Cobros, devoluciones y la licencia de cada uno',
    'payAdmin.title': 'Pagos (Stripe)',
    'payAdmin.search': 'Buscar por correo, clave o referencia',
    'payAdmin.mode.test': 'MODO PRUEBA: pagos de prueba, no son reales',
    'payAdmin.mode.live': 'MODO REAL',
    'payAdmin.mode.none': 'Sin Stripe',
    'payAdmin.truncated': 'Se muestran los 500 últimos cobros.',
    'payAdmin.net': 'Cobrado (neto)',
    'payAdmin.last30': 'Últimos 30 días',
    'payAdmin.refunded': 'Devuelto',
    'payAdmin.count': 'Cobros',
    'payAdmin.stateAll': 'Todos',
    'payAdmin.state.paid': 'Cobrado',
    'payAdmin.state.refunded': 'Devuelto',
    'payAdmin.state.partial': 'Devuelto en parte',
    'payAdmin.state.failed': 'Fallido',
    'payAdmin.state.pending': 'Pendiente',
    'payAdmin.kind.license': 'Licencia',
    'payAdmin.kind.extra': '{n} dispositivo(s) extra',
    'payAdmin.kind.unlinked': 'Sin licencia vinculada',
    'payAdmin.kindChip.license': 'Licencias',
    'payAdmin.kindChip.extra': 'Dispositivos extra',
    'payAdmin.kindChip.unlinked': 'Sin vincular',
    'payAdmin.refundedOf': 'devueltos {amount}',
    'payAdmin.receipt': 'Recibo',
    'payAdmin.refresh': 'Actualizar desde Stripe',
    'payAdmin.found': '{n} pagos · mostrando {shown}',
    'payAdmin.empty': 'No hay pagos',
    'payAdmin.notConfigured': 'Stripe no está configurado en el servidor.',
    'payAdmin.stripeError': 'Stripe no ha respondido. Inténtalo de nuevo.',
    'share.evicted': '«{name}» lo está usando su dueño y no quedan conexiones libres. Inténtalo más tarde.',
    'share.providerBy': 'Compartido por {who}',
    'share.providerWith': 'Compartido con {n} persona(s)',
    'share.sharedName': 'Fuente compartida',
    'share.menu': 'Compartir con otra cuenta…',
    'share.leave': 'Dejar de ver esta fuente',
    'share.leaveConfirm': '«{name}» lo comparte {who}. Dejarás de verlo; quien lo comparte lo conserva.',
    'share.addHint': 'Correo de la persona (con ese correo entrará a Filoteca)',
    'share.add': 'Añadir persona',
    'share.added': 'Compartido con {email}',
    'share.errSelf': 'Es tu propio correo.',
    'share.errEmail': 'Ese correo no es válido.',
    'share.removeConfirm': '{email} dejará de ver esta fuente.',
    'share.remove': 'Quitar acceso',
    'share.title': 'Compartido: {name}',
    'share.none': 'Aún no lo compartes con nadie',
    'share.note': 'No verán tus credenciales. Si la fuente se llena, tienes prioridad.',
    'share.newOne': '{who} ha compartido «{name}» contigo',
    'share.newMany': 'Tienes {n} fuentes compartidas nuevas',
    'share.revoked': '«{name}» ya no está compartido contigo.',
    'share.redeem': 'Tengo un código de invitación',
    'share.redeemSub': 'Añade una fuente que otra persona comparte contigo',
    'share.redeemHint': 'Escribe el código (por ejemplo K7M2X-9QPAB)',
    'share.redeemed': 'Ya tienes «{name}», compartido por {who}',
    'share.badCode': 'Ese código no es válido o ya caducó.',
    'share.tooMany': 'Demasiados intentos. Espera un poco.',
    'settings.heroInterval': 'Cambio automático de la cabecera',
    'settings.heroIntervalSub': 'Cada cuánto pasa solo el carrusel de destacados (Inicio, Películas y Series)',
    'settings.heroIntervalOff': 'No cambia solo',
    'settings.heroIntervalSec': '{n} s',
    'settings.continueChannels': 'Canales en «Continuar viendo»',
    'settings.continueChannelsSub': 'Los canales que has visto hace poco salen junto a películas y series en el Inicio',
    'settings.tabAccount': 'Perfil',
    'settings.tabSources': 'Fuentes',
    'settings.tabAppearance': 'Aspecto',
    'settings.tabPlayback': 'Reproducción',
    'settings.tabDevices': 'Dispositivos',
    'settings.tabMore': 'Más',
    'settings.tvHintToggle': 'Pulsa OK para activarlo o desactivarlo',
    'settings.tvHintOpen': 'Pulsa OK para abrirlo o cambiarlo',
    'settings.fireLayout': 'Ajustes y menús tipo Fire TV',
    'settings.fireLayoutSub': 'Mosaicos y tres columnas, como en la tele (en la tele ya es así)',
    'settings.liveView': 'Vista de TV en directo',
    'settings.liveViewSub': 'La que se abre al entrar. «Panel con vista previa» lleva la barra de menús arriba o a un lado y sirve de pantalla de siempre',
    'settings.episodeView': 'Episodios',
    'settings.episodeViewSub': 'Cómo se ven los episodios de una serie',
    'settings.viewAuto': 'Automático (tarjetas en pantallas grandes)',
    'settings.viewCards': 'Tarjetas con imagen',
    'settings.viewList': 'Lista',
    'settings.detailHeader': 'Información de la ficha',
    'settings.detailHeaderSub': 'Qué se ve bajo el título; el resto está en «Más información»',
    'settings.detailSummary': 'Resumida',
    'settings.detailFull': 'Completa',
    'settings.trailerButton': 'Botón «Tráiler» en la ficha',
    'settings.trailerButtonSub': 'Además de reproducirse solo en la portada, un botón para verlo con sonido',
    'preview.sound': 'Activar sonido',
    'preview.soundOn': 'Activar el sonido de las vistas previas',
    'preview.soundOff': 'Silenciar las vistas previas',
    'peek.soundHint': 'Mantén OK: sonido',
    'preview.pause': 'Pausar tráiler',
    'preview.play': 'Reanudar tráiler',
    'relay.title': 'Escribir con el móvil',
    'relay.step1': 'Escanea el QR con el móvil, o entra en {url} y escribe el código. Funciona desde cualquier red.',
    'relay.field': 'Campo: {name}',
    'relay.fields': 'Formulario de {n} campos',
    'relay.fieldN': 'Campo {n}',
    'relay.code': 'Código',
    'relay.waiting': 'Esperando al móvil…',
    'relay.connected': 'Móvil conectado. Escribe en el móvil.',
    'relay.ended': 'El móvil se ha desconectado.',
    'relay.privacy': 'El texto viaja cifrado y no se guarda.',
    'relay.done': 'Listo',
    'relay.error': 'No se pudo conectar con el servidor. Se usa el teclado de la tele.',
    'relay.choice.title': 'Escribir en este campo',
    'relay.choice.phone': 'Con el móvil (QR)',
    'relay.choice.tv': 'Con el teclado de la tele',
    'settings.liveFormat': 'Formato de canales en directo',
    'settings.liveFormatSub': 'HLS (m3u8) es compatible con más dispositivos; TS requiere el proxy.',
    'settings.seekPreview': 'Miniatura al buscar en el vídeo',
    'settings.nativePlayer': 'Reproductor nativo de Android',
    'settings.nativePlayerSub': 'Usa el reproductor del sistema: admite más formatos y audio Dolby/DTS sin servidor. Si falla, se usa el del navegador.',
    'phone.button': 'Añadir desde el móvil',
    'external.title': 'Abrir en el móvil',
    'external.text': 'Esta tele no puede abrir el enlace. Escanea el código con el móvil para abrirlo ahí.',
    'phone.title': 'Añadir desde el móvil',
    'phone.step1': 'Conecta el móvil a la misma wifi que esta tele.',
    'phone.step2': 'Escanea el código o abre esta dirección en el navegador del móvil:',
    'phone.pin': 'PIN',
    'phone.waiting': 'Esperando los datos desde el móvil…',
    'phone.waitingMore': 'Añadido. Puedes enviar otro o pulsar «Listo».',
    'phone.added': 'Añadido: {name}',
    'phone.done': 'Listo',
    'phone.noNetwork': 'Esta tele no está conectada a una red. Conéctala por wifi o cable.',
    'phone.locked': 'Demasiados PIN erróneos. Espera un minuto.',
    'phone.stopped': 'La página se ha cerrado. Ábrela de nuevo desde aquí.',
    'phone.error': 'No se pudo abrir la página en la red de casa.',
    'settings.tmdbGroup': 'Fichas',
    'settings.tmdbGroupLocal': 'Fichas y subtítulos',
    'settings.os': 'Clave de OpenSubtitles',
    'settings.osSub': 'Subtítulos de internet para películas y series',
    'settings.osOnAccount': 'Configurada, con cuenta',
    'settings.osHelp': 'Sin servidor, cada persona usa su propia clave, gratuita: en opensubtitles.com crea una cuenta y pide una clave en «API Consumers». Se guarda solo en este dispositivo.',
    'settings.osKeyLabel': 'Clave de API',
    'settings.osAccountHelp': 'Opcional: con tu usuario y contraseña de opensubtitles.com tienes más descargas al día.',
    'settings.osUser': 'Usuario (opcional)',
    'settings.osPass': 'Contraseña (opcional)',
    'settings.osInvalid': 'OpenSubtitles no acepta esa clave. Revísala.',
    'settings.osSaved': 'Clave guardada. Los subtítulos se buscarán al reproducir.',
    'settings.tmdb': 'Clave de TMDB',
    'settings.tmdbSub': 'Reparto con fotos, edad, mejores sinopsis y la fila de Tendencias',
    'settings.tmdbOn': 'Configurada',
    'settings.tmdbHelp': 'Sin servidor, cada persona usa su propia clave, gratuita: en themoviedb.org crea una cuenta y pídela en Ajustes → API. Se guarda solo en este dispositivo.',
    'settings.tmdbKeyLabel': 'Clave de API (v3) o token de lectura (v4)',
    'settings.tmdbRemove': 'Quitar',
    'settings.tmdbEmpty': 'Escribe la clave.',
    'settings.tmdbInvalid': 'TMDB no acepta esa clave. Revísala.',
    'settings.tmdbUnreachable': 'No se pudo comprobar la clave. Revisa la conexión.',
    'settings.tmdbSaved': 'Clave guardada. Las fichas se completarán al abrirlas.',
    'settings.tmdbAttribution': 'Este producto usa la API de TMDB pero no está avalado ni certificado por TMDB.',
    'settings.seekPreviewSub': 'Enseña el momento al pasar por la barra de progreso. Usa otra conexión del proveedor mientras se muestra',
    'settings.rememberPosition': 'Recordar posición de reproducción',
    'settings.prefetchFocus': 'Preparar al enfocar',
    'settings.prefetchFocusSub': 'Al pararte sobre un canal se le pide ya su lista al proveedor, para que arranque antes al pulsar Play',
    'settings.playerBeta': 'Reproductor beta: arranque instantáneo',
    'settings.playerBetaSub': 'Precarga en el reproductor nativo el canal sobre el que te paras, para que al pulsar Play arranque casi al momento. En pruebas: si da problemas, apágalo.',
    'rec.title': 'Grabaciones',
    'rec.record': 'Grabar',
    'rec.manage': 'Ver grabaciones',
    'rec.schedule': 'Grabar este programa',
    'rec.untilEnd': 'Grabar «{title}» hasta las {time}',
    'rec.minutes': 'Grabar {n} min',
    'rec.started': 'Grabando «{title}»',
    'rec.scheduled': 'Programada «{title}» a las {time}',
    'rec.limitsSub': 'Hasta {min} min por grabación, {gb} GB por usuario, se borran a los {days} días',
    'rec.empty': 'Todavía no hay grabaciones',
    'rec.emptyText': 'Desde un canal en directo pulsa el botón de grabar, o programa un programa desde la guía.',
    'rec.status.scheduled': 'Programada',
    'rec.status.recording': 'Grabando',
    'rec.status.done': 'Lista',
    'rec.status.failed': 'Fallida',
    'rec.play': 'Reproducir',
    'rec.delete': 'Borrar',
    'rec.stop': 'Parar y guardar',
    'rec.stopHere': 'Parar y guardar lo grabado',
    'rec.stopping': 'Guardando…',
    'rec.stopped': 'Grabación parada: «{title}» se está guardando',
    'rec.recordingNow': 'Grabando «{title}»',
    'rec.cancel': 'Cancelar grabación',
    'rec.deleteConfirm': '¿Borrar «{title}»?',
    'rec.usage': 'Usado {used} de {quota}',
    'rec.storageS3': 'en la nube',
    'rec.storageLocal': 'en el servidor',
    'rec.error.generic': 'No se pudo programar la grabación',
    'rec.error.disabled': 'Las grabaciones no están activadas en el servidor',
    'rec.error.too_long': 'Supera la duración máxima permitida',
    'rec.error.quota': 'Has agotado tu espacio de grabaciones; borra alguna',
    'rec.error.quota_total': 'El servidor no tiene más espacio para grabaciones',
    'rec.error.no_space': 'No queda espacio libre en el servidor',
    'rec.error.too_many': 'Demasiadas grabaciones pendientes',
    'rec.error.bad_time': 'Hora de fin no válida',
    'rec.error.too_far': 'Demasiado lejos en el tiempo (máximo 14 días)',
    'rec.error.bad_url': 'Canal sin dirección válida',
    'rec.error.provider_denied': 'El proveedor ha rechazado la conexión (403): revisa que la cuenta esté activa y que no haya otra conexión en uso',
    'rec.error.provider_gone': 'El proveedor ya no tiene este canal (404)',
    'rec.error.provider_error': 'El proveedor no responde bien ahora mismo; se puede reintentar más tarde',
    'rec.error.provider_busy': 'El proveedor no tenía conexiones libres ({active} de {max} en uso): ver la tele en otro aparato también cuenta. Cierra el canal donde no lo estés viendo y vuelve a programarla',
    'rec.error.stalled': 'El proveedor no envió vídeo (conexión colgada)',
    'rec.error.missed': 'La hora de fin pasó antes de poder empezar',
    'rec.error.too_many_concurrent': 'Había demasiadas grabaciones a la vez en el servidor',
    'rec.waitingConn': 'Esperando una conexión libre del proveedor ({active} de {max} en uso)',
    'rec.connWarnTitle': 'Sin conexiones libres',
    'rec.connWarn': 'Tu proveedor tiene todas sus conexiones ocupadas ({active} de {max}) y grabar necesita una más (ver el canal aquí ya usa una). Si sigues, la grabación esperará a que quede una libre; para asegurarla, cierra el canal en otro aparato. ¿Programar igualmente?',
    'rec.error.unauthorized': 'Inicia sesión para grabar',
    'rec.incomplete': 'incompleta',
    'rec.incompleteOf': 'incompleta: {got} de {want}',
    'settings.data': 'Datos y caché',
    'settings.refreshCatalog': 'Actualizar catálogo',
    'settings.refreshCatalogSub': 'Vuelve a descargar canales, películas y series',
    'settings.refreshEpg': 'Actualizar guía EPG',
    'settings.epgFailed': 'No se pudo cargar la guía: {reason}',
    'settings.epgGzip': 'este dispositivo no sabe abrir guías comprimidas',
    'settings.epgTimeout': 'el servidor tardó demasiado',
    'settings.epgUpdated': 'Última actualización: {date}',
    'settings.epgNever': 'Nunca descargada',
    'settings.clearCache': 'Borrar caché local',
    'settings.clearCacheSub': 'Elimina catálogo y EPG guardados (no borra perfiles ni Mi lista)',
    'settings.cleared': 'Caché borrada',
    'settings.network': 'Red',
    'settings.proxy': 'Proxy CORS',
    'settings.proxySub': 'Necesario solo en navegador cuando el servidor bloquea peticiones. Ej. http://localhost:8787/proxy',
    'settings.proxyPh': 'URL del proxy (vacío = sin proxy)',
    'who.title': '¿Quién está viendo?',
    'who.tagline': 'Tu espacio. Tus historias.',
    'who.hintChoose': 'Elegir',
    'who.hintEnter': 'Entrar',
    'who.add': 'Añadir',
    'who.autoIn': 'Entrando como {name} en {n} s · toca o pulsa algo para elegir otro',
    'settings.viewerAuto': 'Entrar solo al abrir la app',
    'settings.viewerAutoSub': 'Si nadie elige en «¿Quién está viendo?», entra el último espectador pasado este tiempo',
    'settings.viewerAutoOff': 'No entrar solo',
    'who.manage': 'Gestionar perfiles',
    'who.done': 'Listo',
    'who.edit': 'Editar espectador',
    'who.new': 'Nuevo espectador',
    'who.name': 'Nombre',
    'who.namePh': 'Ej. Mamá, Lucas…',
    'who.avatar': 'Color',
    'who.kids': 'Perfil infantil',
    'who.kidsSub': 'Solo contenido apto para todos los públicos; no puede desbloquear categorías con PIN',
    'who.kidsBadge': 'Infantil',
    'who.delete': 'Eliminar espectador',
    'who.deleteConfirm': '¿Eliminar a {name}? Se perderán su lista y su progreso.',
    'who.limit': 'Máximo 5 espectadores por cuenta',
    'who.kidsLocked': 'Este perfil es infantil y no puede ver ese contenido.',
    'who.clearHistory': 'Borrar historial',
    'who.clearHistoryConfirm': '¿Vaciar "Continuar viendo", canales recientes y Mi lista de {name}? Las fuentes no se tocan.',
    'who.historyCleared': 'Historial borrado',
    'who.me': 'Yo',
    'settings.viewers': 'Espectadores',
    'settings.currentViewer': 'Viendo como',
    'settings.switchViewer': 'Cambiar de espectador',
    'settings.filoteca': 'Cuenta Filoteca',
    'demo.bar': "Demo de Filoteca: Cine clásico y canales en abierto. Lo que marques se queda solo en tu navegador.",
    'demo.download': "Descargar la app",
    'demo.full': "Pantalla completa",
    'demo.settingsTitle': "Estás en la demo",
    'demo.settingsSub': "Cuenta compartida de solo lectura: tus propias fuentes, solo en la app instalada",
    'demo.exit': "Salir de la demo",
    'demo.tryPremium': "Probar Premium gratis",
    'demo.liveBlocked': "En la demo solo se reproduce Cine clásico. Los canales se ven con la app instalada.",
    'demo.testMode': "Modo de pruebas · sin límite",
    'demo.noneHint': "La demo solo incluye Cine clásico y algunos canales en abierto. Con la app instalada añades tus propias fuentes.",
    'demo.left': "Quedan {t}",
    'demo.endedTitle': "La demo ha terminado",
    'demo.endedText': "Han pasado los minutos de la demo. Para seguir, pide tu prueba de Premium: es gratis durante la beta.",
    'demo.limitText': "Ya has usado la demo hoy. Para seguir, pide tu prueba de Premium: es gratis durante la beta.",
    'demo.backHome': "Volver a filoteca.com",
    'login.pw.subtitle': 'Entra con tu correo o con Google.',
    'login.pw.tabLogin': 'Entrar',
    'login.pw.tabRegister': 'Crear cuenta',
    'login.pw.name': 'Nombre (opcional)',
    'login.pw.email': 'Correo electrónico',
    'login.pw.password': 'Contraseña',
    'login.pw.passwordHelp': 'Mínimo 8 caracteres. Evita las contraseñas típicas.',
    'login.pw.forgot': '¿Has olvidado la contraseña?',
    'login.pw.notAllowed': 'Este correo no está autorizado en Filoteca. Pide al administrador que te dé de alta.',
    'login.pw.show': 'Mostrar contraseña',
    'login.pw.hide': 'Ocultar contraseña',
    'login.pw.submitLogin': 'Entrar',
    'login.pw.submitRegister': 'Crear cuenta',
    'login.pw.or': 'o',
    'login.pw.forgotIntro': 'Escribe tu correo y te enviaremos un código para elegir una contraseña nueva.',
    'login.pw.sendCode': 'Enviar código',
    'login.pw.code': 'Código de 6 cifras',
    'login.pw.codeSent': 'Hemos enviado un código a {email}. Caduca en {min} minutos. Mira también la carpeta de spam.',
    'login.pw.verify': 'Verificar y entrar',
    'login.pw.reset': 'Cambiar contraseña y entrar',
    'login.pw.newPassword': 'Nueva contraseña',
    'login.pw.resend': 'Reenviar código',
    'login.pw.resendIn': 'Reenviar en {n} s',
    'login.pw.resent': 'Código enviado',
    'login.pw.back': 'Volver',
    'login.pw.error.fields': 'Escribe tu correo y tu contraseña.',
    'login.pw.error.generic': 'No se pudo completar. Inténtalo de nuevo.',
    'twofa.title': 'Verificación en dos pasos',
    'twofa.sub': 'Protege tu cuenta de administrador con un código de tu móvil',
    'twofa.on': 'Activa',
    'twofa.off': 'Sin activar',
    'twofa.askTitle': 'Verificación en dos pasos',
    'twofa.askText': 'Escribe el código de 6 cifras de tu aplicación de autenticación (o un código de recuperación).',
    'twofa.askRetry': 'Código incorrecto. Prueba con el código actual de tu aplicación (o un código de recuperación).',
    'twofa.ok': 'Continuar',
    'twofa.enableTitle': 'Activar la verificación en dos pasos',
    'twofa.enableText': 'Escanea el código QR con una aplicación de autenticación (Google Authenticator, Aegis, Authy…) o escribe la clave a mano. Después escribe el código de 6 cifras que te muestre.',
    'twofa.secretLabel': 'Clave',
    'twofa.codePlaceholder': 'Código de 6 cifras',
    'twofa.activate': 'Activar',
    'twofa.enabledToast': 'Verificación en dos pasos activada',
    'twofa.recoveryTitle': 'Guarda tus códigos de recuperación',
    'twofa.recoveryText': 'Cada código sirve una sola vez si pierdes el móvil. Guárdalos en un lugar seguro: no se volverán a mostrar.',
    'twofa.copy': 'Copiar',
    'twofa.copied': 'Códigos copiados',
    'twofa.statusText': 'La verificación en dos pasos está activa. Códigos de recuperación sin usar: {n}.',
    'twofa.disable': 'Desactivar',
    'twofa.disableText': 'Para desactivarla, escribe un código actual de tu aplicación (o uno de recuperación).',
    'twofa.disabledToast': 'Verificación en dos pasos desactivada',
    'twofa.invalid': 'Código incorrecto',
    'twofa.recoveryUsed': 'Has usado un código de recuperación; te quedan {n}. Conviene crear otros desactivando y activando de nuevo la verificación.',
    'login.pw.error.invalid_code': 'El código no es correcto.',
    'login.pw.error.twofa_expired': 'Ha caducado el paso de verificación. Vuelve a entrar.',
    'login.pw.error.invalid_credentials': 'Correo o contraseña incorrectos.',
    'login.pw.error.wrong_current_password': 'La contraseña actual no es correcta.',
    'login.pw.error.invalid_email': 'Escribe un correo válido.',
    'login.pw.error.weak_password': 'La contraseña es demasiado débil: usa al menos 8 caracteres y evita las típicas.',
    'login.pw.error.email_taken': 'Ya hay una cuenta con ese correo. Entra, o recupera la contraseña.',
    'login.pw.error.code_invalid': 'El código no es correcto.',
    'login.pw.error.code_expired': 'El código ha caducado. Pide uno nuevo.',
    'login.pw.error.too_many_attempts': 'Demasiados intentos. Espera unos minutos o pide un código nuevo.',
    'login.pw.error.code_cooldown': 'Espera un minuto antes de pedir otro código.',
    'login.pw.error.rate_limited': 'Demasiadas peticiones. Inténtalo más tarde.',
    'login.pw.error.mail_failed': 'No se pudo enviar el correo. Inténtalo más tarde.',
    'settings.changePassword': 'Cambiar contraseña',
    'settings.setPassword': 'Crear una contraseña',
    'settings.passwordSub': 'Para entrar también con tu correo',
    'settings.currentPassword': 'Contraseña actual',
    'settings.newPassword': 'Nueva contraseña',
    'settings.repeatPassword': 'Repite la nueva contraseña',
    'settings.passwordMismatch': 'Las contraseñas no coinciden.',
    'settings.passwordChanged': 'Contraseña guardada. Los demás dispositivos tendrán que volver a entrar.',
    'terms.title': 'Términos de uso',
    'terms.text': 'Para usar Filoteca tienes que aceptar los {terms} y la {privacy}. Filoteca es un reproductor: no incluye contenido, y tú eres responsable de las fuentes que conectes y de tener derecho a verlas.',
    'terms.linkTerms': 'términos de uso',
    'terms.linkPrivacy': 'política de privacidad',
    'terms.accept': 'Acepto',
    'terms.decline': 'No acepto',
    'terms.gate.kicker': 'Antes de empezar',
    'terms.gate.title': 'Términos de uso y privacidad',
    'terms.gate.intro': 'Filoteca es un reproductor. No incluye, no vende ni aloja películas, series ni canales: solo reproduce las fuentes que tú conectas.',
    'terms.gate.p1': 'Tú eliges las fuentes y respondes de ellas: solo puedes conectar contenido que tengas derecho a ver.',
    'terms.gate.p2': 'Uso personal y doméstico. Nada de redistribuir ni retransmitir a terceros.',
    'terms.gate.p3': 'Tus datos: lo imprescindible para que la app funcione (fuentes, perfiles, progreso) y, con cuenta, un recuento anónimo de lo más visto. Puedes borrar tu cuenta y tus datos cuando quieras.',
    'terms.gate.check1': 'Tengo 18 años o más y he leído y acepto los {terms} y la {privacy}.',
    'terms.gate.check2': 'Entiendo que Filoteca no incluye contenido: soy responsable de las fuentes que conecte y de tener derecho a ver lo que emiten.',
    'terms.gate.readFull': 'Leer el texto completo',
    'terms.gate.hideFull': 'Ocultar el texto completo',
    'terms.gate.loading': 'Cargando el texto…',
    'terms.gate.loadFail': 'No se ha podido cargar el texto completo. Puedes leerlo en {terms} y {privacy}.',
    'terms.gate.hint': 'Marca las dos casillas para poder aceptar.',
    'terms.gate.declinedTitle': 'Sin aceptar no se puede usar Filoteca',
    'terms.gate.declinedText': 'No pasa nada: no se ha guardado nada ni se ha tocado tu cuenta. Puedes volver a leer las condiciones y aceptarlas cuando quieras, o salir.',
    'terms.gate.backToRead': 'Volver a leerlas',
    'terms.gate.exit': 'Salir',
    'terms.gate.signOut': 'Cerrar sesión',
    'terms.gate.version': 'Versión {version}',
    'terms.gate.accepting': 'Guardando…',
    'terms.gate.acceptedOn': 'Aceptados el {date} (versión {version})',
    'terms.gate.notAccepted': 'Sin aceptar',
    'settings.termsLink': 'Términos de uso',
    'settings.privacyLink': 'Política de privacidad',
    'telemetry.title': '¿Ayudas a mejorar Filoteca?',
    'telemetry.text': 'Si quieres, la app puede enviar estadísticas anónimas de uso: cuántas veces se abre, cuánto se usa y qué funciones se usan (por ejemplo, reproducciones o búsquedas). Nunca se envían títulos, direcciones, listas, usuarios ni contraseñas, y no se te puede identificar. Puedes cambiarlo cuando quieras en Ajustes.',
    'telemetry.yes': 'Sí, ayudar',
    'telemetry.no': 'No, gracias',
    'settings.telemetry': 'Estadísticas anónimas',
    'settings.telemetrySub': 'Ayuda a mejorar Filoteca enviando cuántas veces se usa cada función. Sin títulos, direcciones ni datos personales',
    'settings.telemetryReset': 'Reiniciar identificador anónimo',
    'settings.telemetryResetSub': 'Filoteca te verá como una instalación nueva y se olvida lo acumulado',
    'settings.telemetryResetDone': 'Identificador reiniciado',
    'usage.title': 'Uso de las apps',
    'usage.dl.title': 'Descargas de las apps ({n} días)',
    'usage.dl.apk': 'APK de Android',
    'usage.dl.windows': 'Windows (instalador)',
    'usage.dl.portable': 'Windows (portátil)',
    'usage.dl.hub': 'Filoteca Hub',
    'usage.dl.sub': 'completadas · {started} iniciadas · {uniques} personas',
    'usage.dl.src': 'Origen de los inicios: desde la web {web} · enlace directo {direct} · desde la propia app {app}',
    'usage.dl.empty': 'Aún no hay descargas registradas.',
    'usage.dl.note': 'Recuento propio del servidor, sin cookies ni terceros ni IP guardada. Las «personas» se cuentan por día.',
    'usage.sub': 'Estadísticas anónimas de quienes las han aceptado',
    'usage.empty': 'Todavía no hay datos.',
    'usage.dau': 'Hoy',
    'usage.wau': '7 días',
    'usage.mau': '30 días',
    'usage.installs': 'Instalaciones',
    'usage.session': 'Sesión media (min)',
    'usage.d1': 'Vuelven al día siguiente',
    'usage.d7': 'Vuelven a los 7 días',
    'usage.fresh': 'Nuevas (30 días)',
    'usage.versions': 'Versiones',
    'usage.platforms': 'Plataformas',
    'usage.langs': 'Idiomas',
    'usage.tiers': 'Niveles',
    'usage.features': 'Funciones más usadas (30 días)',
    'usage.refresh': 'Actualizar',
    'usage.active': 'Activos por día',
    'usage.unit': 'aparatos',
    'settings.deleteAccount': 'Borrar mi cuenta y mis datos',
    'settings.deleteAccountSub': 'Elimina tu cuenta, tus fuentes guardadas, tus perfiles y tu progreso',
    'settings.deleteAccountConfirm': 'Se borrará para siempre la cuenta {email} con todos sus datos: fuentes guardadas, perfiles, listas, progreso y grabaciones. No se puede deshacer.',
    'settings.deleteAccountLastAdmin': 'Eres el único administrador: nombra a otro antes de borrar tu cuenta.',
    'settings.deleteAccountDone': 'Cuenta borrada',
    'login.registrationFull': 'Se ha alcanzado el máximo de usuarios. Vuelve a intentarlo más adelante.',
    'settings.signedAs': 'Sesión iniciada',
    'settings.pairTv': 'Vincular una TV',
    'settings.pairTvSub': 'Introduce el código que muestra la TV',
    'settings.devices': 'Dispositivos',
    'settings.devicesSub': 'Sesiones abiertas con tu cuenta; cierra las que no reconozcas',
    'devices.title': 'Dispositivos',
    'devices.thisDevice': 'Este dispositivo',
    'devices.lastSeen': 'Última actividad: {date}',
    'devices.remove': 'Cerrar sesión en este dispositivo',
    'devices.removeConfirm': '¿Cerrar la sesión de «{name}»? Ese dispositivo tendrá que volver a entrar.',
    'devices.rename': 'Renombrar',
    'devices.renamePrompt': 'Nombre del dispositivo',
    'devices.removed': 'Sesión cerrada',
    'devices.empty': 'No hay dispositivos',
    'settings.signOutGoogle': 'Cerrar sesión',
    'settings.signOutConfirm': 'Se cerrará la sesión en este dispositivo. Tus fuentes siguen guardadas en tu cuenta.',
    'settings.admin': 'Administración',
    'settings.users': 'Usuarios autorizados',
    'settings.usersSub': 'Quién puede entrar en Filoteca',
    'settings.serverUrl': 'Servidor de cuentas',
    'settings.serverUrlSub': 'Dirección de tu servidor Filoteca (vacío = filoteca.com)',
    'settings.parental': 'Control parental',
    'settings.parentalEnable': 'Bloquear categorías para adultos',
    'settings.parentalPin': 'Cambiar PIN',
    'settings.parentalCategories': 'Categorías bloqueadas',
    'parental.catsHelp': "Marca las categorías que quedan bloqueadas hasta introducir el PIN. Están agrupadas por fuente.",
    'parental.catSearch': "Buscar categoría",
    'parental.markAll': "Marcar todo",
    'parental.unmarkAll': "Quitar todo",
    'parental.catCount': "{n} de {total} bloqueadas",
    'parental.kind.live': "Directo",
    'parental.kind.vod': "Películas",
    'parental.kind.series': "Series",
    'settings.parentalSetPin': 'Elige un PIN de 4 dígitos',
    'settings.parentalConfirmPin': 'Repite el PIN',
    'settings.parentalEnterPin': 'Introduce el PIN',
    'settings.parentalWrong': 'PIN incorrecto',
    'settings.parentalMismatch': 'Los PIN no coinciden',
    'settings.about': 'Acerca de',
    'settings.version': 'Versión',
    'settings.diagnostics': 'Diagnóstico',
    'settings.safeAreas': 'Zonas seguras',
    'settings.safeAreasSub': 'Espacio que la app deja bajo la barra de estado y la de navegación. 0 y 0: la app no está a pantalla completa.',
    'settings.platform': 'Plataforma',
    'settings.hls': 'Motor HLS',
    'settings.logout': 'Cerrar sesión',
    'settings.updated': 'Ajustes guardados',
    'settings.catalogUpdated': 'Catálogo actualizado',
    'settings.catalogUpdating': 'Actualizando catálogo…',

    'offline.title': 'Descargas',
    'offline.download': 'Descargar',
    'offline.downloaded': 'Descargado',
    'offline.downloading': 'Descargando',
    'offline.queued': 'En cola',
    'offline.paused': 'En pausa',
    'offline.waiting': 'Esperando conexión',
    'offline.retry': 'Reintentar',
    'offline.pause': 'Pausar',
    'offline.resume': 'Reanudar descarga',
    'offline.play': 'Ver sin conexión',
    'offline.delete': 'Eliminar descarga',
    'offline.cancel': 'Cancelar descarga',
    'offline.seeAll': 'Ver descargas',
    'offline.started': 'Descarga añadida',
    'offline.finished': 'Descarga completada: {title}',
    'offline.failed': 'No se pudo descargar: {title}',
    'offline.needNetwork': 'Para descargar hace falta conexión',
    'offline.deleteConfirm': '¿Eliminar «{title}» de este dispositivo?',
    'offline.cancelConfirm': '¿Cancelar la descarga de «{title}»? Se borrará lo ya descargado.',
    'offline.usage': '{used} en descargas · {free} libres en este dispositivo',
    'offline.usageUsed': '{used} en descargas',
    'offline.keepOpen': 'Mantén Filoteca abierta mientras se descarga. Si la cierras, seguirá donde lo dejó al volver a abrirla.',
    'offline.emptyTitle': 'Todavía no hay descargas',
    'offline.emptyText': 'En la ficha de una película o en un episodio, pulsa «Descargar» para verlo después sin conexión.',
    'offline.unsupportedTitle': 'Este navegador no permite descargas',
    'offline.unsupportedText': 'Usa Chrome o Edge, o la app de Android, para guardar películas y episodios en el dispositivo.',
    'offline.startup': 'Sin conexión: aquí tienes tus descargas',
    'offline.error.generic': 'No se pudo completar la descarga',
    'offline.error.network': 'Se perdió la conexión demasiadas veces',
    'offline.error.no_space': 'No hay espacio suficiente en el dispositivo',
    'offline.error.bad_content': 'El proveedor no ha devuelto un vídeo',
    'offline.error.unsupported': 'Este título se emite por fragmentos y no se puede descargar',
    'offline.error.http_401': 'El proveedor ha rechazado la descarga',
    'offline.error.http_403': 'El proveedor ha rechazado la descarga',
    'offline.error.http_404': 'El proveedor ya no tiene este título',
    'offline.error.incomplete': 'La descarga quedó incompleta',
    'offline.error.empty': 'El proveedor ha devuelto un archivo vacío',

    'subs.title': 'Buscar subtítulos',
    'subs.search': 'Buscar subtítulos en internet',
    'subs.searchOther': 'Probar otros subtítulos',
    'subs.language': 'Idioma',
    'subs.results': 'Resultados',
    'subs.none': 'No hay subtítulos en {lang} para este título',
    'subs.downloads': '{n} descargas',
    'subs.hearingImpaired': 'Para sordos',
    'subs.machine': 'Traducción automática',
    'subs.loaded': 'Subtítulos cargados',
    'subs.errorSearch': 'No se pudo buscar. Inténtalo de nuevo.',
    'subs.errorLoad': 'No se pudieron cargar estos subtítulos',
    'subs.errorQuota': 'Se ha agotado el cupo de descargas de subtítulos de hoy',
    'subs.sync': 'Sincronización',
    'subs.inSync': 'Sin ajuste',
    'subs.earlier': 'Adelantar medio segundo',
    'subs.later': 'Retrasar medio segundo',
    'subs.syncHint': 'Si el texto sale tarde, pulsa −; si sale antes de tiempo, pulsa +. Si no cuadra en toda la película, prueba otros subtítulos.',
    'settings.subtitlesAuto': 'Subtítulos automáticos',
    'settings.subtitlesAutoSub': 'Busca y carga subtítulos al empezar cada película o episodio',
    'settings.subtitleLang': 'Idioma de los subtítulos',

    'sub.state.active': 'Activa',
    'sub.state.expiring': 'Caduca pronto',
    'sub.state.expired': 'Caducada',
    'sub.state.disabled': 'Deshabilitada',
    'sub.state.unknown': 'Sin comprobar',
    'sub.state.offline': 'No responde',
    'sub.state.rejected': 'Credenciales rechazadas',
    'sub.state.list': 'Lista',
    'sub.trial': 'de prueba',
    'sub.never': 'Sin fecha de caducidad',
    'sub.expiresOn': 'Caduca el {date}',
    'sub.expiredOn': 'Caducó el {date}',
    'sub.daysLeft': 'quedan {n} días',
    'sub.dayLeft': 'queda 1 día',
    'sub.today': 'hoy',
    'sub.tomorrow': 'mañana',
    'sub.inDays': 'en {n} días',
    'sub.daysAgo': 'hace {n} días',
    'sub.yesterday': 'ayer',
    'sub.connections': '{active} de {max} conexiones en uso',
    'sub.lastKnown': 'El proveedor no responde: se muestra lo último que se sabía',
    'sub.rejectedText': 'El proveedor rechaza el usuario o la contraseña, o ha dado de baja la cuenta',
    'sub.simulated': '(Simulación)',
    'sub.checking': 'Comprobando…',
    'sub.recheck': 'Comprobar de nuevo',
    'sub.manage': 'Fuentes',
    'sub.stillExpired': 'La suscripción sigue sin estar activa',
    'sub.nowActive': 'La suscripción está activa',
    'sub.noticeExpiredTitle': 'La suscripción de «{name}» ha caducado',
    'sub.noticeExpiredText': 'Caducó el {date}. Puedes seguir viendo el catálogo y tus descargas, pero no reproducir lo demás hasta renovarla con tu proveedor.',
    'sub.noticeExpiredTextNoDate': 'Puedes seguir viendo el catálogo y tus descargas, pero no reproducir lo demás hasta renovarla con tu proveedor.',
    'sub.noticeDisabledTitle': 'El proveedor «{name}» ha deshabilitado la cuenta',
    'sub.noticeDisabledText': 'No se puede reproducir. Revisa el usuario y la contraseña o ponte en contacto con tu proveedor.',
    'sub.noticeSoonTitle': 'La suscripción de «{name}» caduca {when}',
    'sub.noticeSoonText': 'Renuévala con tu proveedor antes del {date} para no quedarte sin servicio.',
    'player.fallback': '«{from}» no responde. Probando con «{to}»…',
    'player.fallbackTo': 'Probando con «{to}»…',
    'player.expiredTitle': 'Tu suscripción ha caducado',
    'player.expiredText': 'La suscripción de «{name}» caducó el {date}. Renuévala con tu proveedor para seguir viendo.',
    'player.expiredTextNoDate': 'La suscripción de «{name}» ha caducado. Renuévala con tu proveedor para seguir viendo.',
    'player.disabledTitle': 'Cuenta deshabilitada',
    'player.disabledText': 'El proveedor «{name}» ha deshabilitado la cuenta. Revisa el usuario y la contraseña o ponte en contacto con él.',
    'login.connectedExpired': 'Fuente añadida, pero su suscripción está caducada',
    'settings.providers': 'Fuentes',
    'settings.providerInUse': 'Principal',
    'settings.providerUse': 'Hacer principal',
    'settings.providerCheck': 'Comprobar ahora',
    'settings.providerPersonal': 'Vídeos personales (sin TMDB)',
    'settings.providerPersonalOn': 'Carpeta de vídeos personales: sin carátulas ni fichas de TMDB',
    'settings.providerPersonalOff': 'Carpeta de películas y series: con carátulas de TMDB',
    'settings.providerXtream': 'Xtream',
    'settings.providerM3u': 'Lista M3U',
    'settings.addProviderSub': 'Puedes tener varios y juntar sus catálogos',
    'settings.deleteProviderDownloads': 'También se eliminarán sus {n} descargas de este dispositivo.',
    'settings.simulate': 'Simular suscripción',
    'settings.simulateSub': 'Para ver los avisos de caducidad. Se quita al cerrar la app.',
    'settings.simulateOff': 'No',
    'settings.simulateSoon': 'Caduca en 3 días',
    'settings.simulateExpired': 'Caducada',

    'settings.providerOn': 'Activado',
    'settings.providerOff': 'Desactivado',
    'settings.providerSwitch': 'Activar o desactivar {name}',
    'settings.providerOnlyOne': 'Es la única fuente que tienes. Añade otra para poder desactivar esta.',
    'settings.providerOffMain': '«{name}» es el principal. Si lo desactivas, «{next}» pasará a ser el principal: guardará tu lista y tu progreso desde ahora. Lo que ya tenías sigue en «{name}».',
    'settings.providerOffTitle': 'Desactivar «{name}»',
    'settings.providerInclude': 'Añadir al catálogo',
    'settings.providerIncluded': 'En el catálogo',
    'settings.providerLoading': 'Cargando su catálogo…',
    'settings.providerLoadError': 'No se pudo cargar su catálogo',
    'settings.providerAdds': 'Aporta {movies} películas, {series} series y {channels} canales que no tenías',
    'settings.providerBackup': '{n} títulos repetidos quedan como respaldo',
    'settings.providerAdded': 'Catálogo ampliado con {n} títulos nuevos',
    'settings.providersHint': 'La fuente principal guarda tu lista y tu progreso. Las que añadas al catálogo suman sus títulos, y lo que esté repetido sirve de respaldo si una falla.',
    'sub.noticeBackup': 'Lo que también esté en tus otras fuentes se sigue pudiendo ver.',
    'detail.provider': 'Fuente',
    'detail.alsoIn': 'también en {names}',

    'login.group.iptv': 'Televisión',
    'login.group.library': 'Biblioteca propia',
    'login.type.xtream': 'Xtream Codes',
    'login.type.m3u': 'Lista M3U',
    'login.type.jellyfin': 'Jellyfin',
    'login.type.emby': 'Emby',
    'login.type.plex': 'Plex',
    'login.hostPh.xtream': 'http://servidor.com:8080',
    'login.hostPh.jellyfin': 'https://jellyfin.midominio.com',
    'login.hostPh.emby': 'https://emby.midominio.com',
    'login.hostPh.plex': 'https://plex.midominio.com:32400',
    'login.libraryHint': 'Tus propias películas y series. Desde la web solo se llega a servidores publicados en internet; a uno de tu red local se llega desde la app de Android.',
    'login.moreInSettings': 'Podrás añadir más fuentes en Ajustes → Fuentes.',
    'login.plexToken': 'Token de Plex',
    'login.plexTokenHelp': 'En Plex Web, abre cualquier título, «Obtener información» → «Ver XML»: el token es lo que sigue a X-Plex-Token= en la dirección.',
    'login.errorToken': 'El servidor Plex no acepta ese token.',
    'login.errorLibrary': 'No se pudo llegar al servidor. Revisa la dirección. Si está en tu red local, conéctalo desde la app de Android.',
    'settings.providerKind.xtream': 'Xtream',
    'settings.providerKind.m3u': 'Lista M3U',
    'settings.providerKind.jellyfin': 'Biblioteca · Jellyfin',
    'settings.providerKind.emby': 'Biblioteca · Emby',
    'settings.providerKind.plex': 'Biblioteca · Plex',
    'sub.own': 'Biblioteca propia: no caduca',

    'login.group.files': 'Archivos propios',
    'login.type.files': 'Carpeta web o WebDAV',
    'login.hostPh.files': 'https://nas.midominio.com/videos',
    'login.filesHint': 'Una carpeta con tus vídeos publicada por web o por WebDAV (NAS, Nextcloud…). Filoteca reconoce películas y series por el nombre de los ficheros — «Título (Año).mkv», «Serie S01E02.mkv» — y les pone carátula. Usuario y contraseña, solo si la carpeta los pide.',
    'login.errorFiles': 'No se pudo leer la carpeta. Revisa la dirección. Si está en tu red local, conéctala desde la app de Android.',
    'login.errorFilesAuth': 'La carpeta pide usuario y contraseña, o los indicados no valen.',
    'login.errorFilesEmpty': 'En esa dirección no hay carpetas ni vídeos.',
    'settings.providerKind.files': 'Archivos propios',
    'login.group.free': 'Canales gratuitos',
    'login.type.free': 'Emisiones en abierto',
    'login.tab.free': 'Contenido en abierto',
    'login.tab.library': 'Mi biblioteca',
    'login.tab.files': 'Archivos y red',
    'login.tab.iptv': 'Televisión (IPTV)',
    'login.head.free': 'Contenido en abierto',
    'login.head.library': 'Mi biblioteca',
    'login.head.files': 'Archivos y red',
    'login.head.iptv': 'Televisión (IPTV)',
    'login.freeDesc': 'Accede a canales y emisoras disponibles públicamente en internet.',
    'login.iptvDesc': 'Tu proveedor de televisión: una cuenta Xtream Codes o una lista M3U.',
    'login.country': 'País',
    'login.moreOptions': 'Más opciones',
    'login.discoverShort': 'Buscar en mi red',
    'login.pairTvShort': 'Emparejar con mi tele',
    'login.freeHint': 'La disponibilidad puede variar según el país o la fuente. Filoteca no aloja ni retransmite contenido.',
    'login.freeAlready': 'Ya tienes añadida esa lista.',
    'preset.tdt-tv': 'TDT en abierto',
    'preset.tdt-tv.sub': 'Emisiones oficiales recopiladas por TDTChannels',
    'preset.tdt-radio': 'Radio en abierto',
    'preset.tdt-radio.sub': 'Emisoras en abierto recopiladas por TDTChannels',
    'preset.iptv-org-es': 'Canales públicos de España',
    'preset.iptv-org-es.sub': 'Recopilación de emisiones públicas españolas',
    'preset.archive': 'Cine clásico',
    'preset.archive.sub': 'Selección de películas de dominio público (Internet Archive, en inglés)',
    'login.type.archive': 'Cine clásico',
    'settings.providerKind.archive': 'Cine clásico',
    'archive.genre.horror': 'Terror',
    'archive.genre.scifi': 'Ciencia ficción',
    'archive.genre.silent': 'Cine mudo',
    'archive.genre.comedy': 'Comedia',
    'archive.genre.classic': 'Clásicos',
    'preset.country': 'Canales internacionales',
    'preset.country.sub': 'Emisiones públicamente accesibles · por país',
    'preset.countryName': 'Canales públicos: {name}',
    'settings.providerKind.free': 'Canales gratuitos',
    'sub.state.free': 'Gratuito',
    'player.fallbackStream': 'Esta emisión no responde. Probando otra del mismo canal…',

    'exit.title': 'Salir',
    'exit.text': '¿Quieres cerrar la aplicación?',

    'settings.providerKind.smb': 'Recurso de red (SMB)',
    'settings.providerKind.local': 'Carpeta de este aparato',
    'addsrc.title': 'Añadir fuente',
    'addsrc.sub': '¿Dónde está tu contenido?',
    'addsrc.intro': 'Elige dónde tienes lo que quieres ver. Te vamos guiando paso a paso.',
    'addsrc.step2': 'Elige el tipo',
    'addsrc.step3': 'Escribe los datos',
    'addsrc.back': 'Atrás',
    'addsrc.connect': 'Conectar',
    'addsrc.moreWays': 'Más formas de añadir (tu red, este aparato…)',
    'addsrc.group.device': 'En este aparato',
    'addsrc.group.device.sub': 'Archivos guardados en este móvil, tablet o PC',
    'addsrc.group.network': 'En mi red',
    'addsrc.group.network.sub': 'Tu ordenador, NAS o servidor multimedia',
    'addsrc.group.tv': 'TV y emisiones en directo',
    'addsrc.group.tv.sub': 'Emisiones en abierto y listas de canales',
    'addsrc.type.local': 'Carpeta de este aparato',
    'addsrc.type.local.sub': 'Elige una carpeta y Filoteca la ordena con carátulas y fichas',
    'addsrc.type.smb': 'Recurso de red (SMB)',
    'addsrc.type.smb.sub': 'Una carpeta compartida de un NAS, router o PC',
    'addsrc.type.files': 'Carpeta web o WebDAV',
    'addsrc.type.files.sub': 'Nextcloud, Synology o servidor web',
    'addsrc.type.jellyfin': 'Jellyfin',
    'addsrc.type.jellyfin.sub': 'Tu servidor Jellyfin',
    'addsrc.type.emby': 'Emby',
    'addsrc.type.emby.sub': 'Tu servidor Emby',
    'addsrc.type.plex': 'Plex',
    'addsrc.type.plex.sub': 'Tu servidor Plex',
    'addsrc.type.free': 'Emisiones en abierto',
    'addsrc.type.free.sub': 'Canales públicos y cine de dominio público',
    'addsrc.type.m3u': 'Lista M3U',
    'addsrc.type.m3u.sub': 'Una lista de canales o vídeos que ya tienes',
    'addsrc.type.xtream': 'Cuenta Xtream Codes',
    'addsrc.type.xtream.sub': 'Una cuenta que ya tienes con tu proveedor',
    'addsrc.smb.hint': 'Filoteca lee los vídeos de una carpeta compartida de tu red, solo para verlos: no escribe ni borra nada. El usuario y la contraseña son los de ese recurso.',
    'addsrc.smb.namePh': 'Películas del NAS',
    'addsrc.smb.server': 'Servidor (nombre o dirección)',
    'addsrc.smb.share': 'Carpeta compartida',
    'addsrc.smb.sharePh': 'Películas',
    'addsrc.smb.shareHelp': 'Es el nombre con el que el NAS comparte la carpeta, el primero después del servidor (\\\\servidor\\Películas).',
    'addsrc.smb.path': 'Subcarpeta (opcional)',
    'addsrc.smb.pathPh': 'Cine/Clásicos',
    'addsrc.smb.userHelp': 'Déjalo vacío si la carpeta compartida no pide usuario (invitado). Con un dominio, usa DOMINIO\\usuario.',
    'addsrc.local.hint': 'Elige una carpeta de este aparato. Filoteca solo la lee para mostrarte sus vídeos; no copia nada ni sube nada a internet.',
    'addsrc.local.pick': 'Elegir carpeta',
    'addsrc.local.namePh': 'Mis vídeos',
    'addsrc.err.fields': 'Faltan datos: revisa el servidor y la carpeta compartida.',
    'addsrc.err.auth': 'El usuario o la contraseña no son correctos.',
    'addsrc.err.empty': 'No hemos encontrado vídeos ahí. Revisa la carpeta o la subcarpeta.',
    'addsrc.err.notfound': 'No existe esa carpeta compartida en el servidor. Revisa el nombre.',
    'addsrc.err.unreachable': 'No se llega al servidor. Comprueba que está encendido y en la misma red.',
    'addsrc.err.generic': 'No se ha podido conectar.',
    'addsrc.err.pick': 'Elige primero una carpeta.',
    'addsrc.group.cloud': 'En la nube',
    'addsrc.group.cloud.sub': 'Tus vídeos en Dropbox y OneDrive',
    'addsrc.type.dropbox': 'Dropbox',
    'addsrc.type.dropbox.sub': 'Conecta tu cuenta de Dropbox',
    'addsrc.type.onedrive': 'OneDrive',
    'addsrc.type.onedrive.sub': 'Conecta tu cuenta de Microsoft',
    'addsrc.dropbox.hint': 'Filoteca pide a Dropbox un permiso solo de lectura (no puede cambiar ni borrar nada) y lo puedes retirar cuando quieras desde tu cuenta. 1) Pulsa «Abrir Dropbox» y acepta. 2) Dropbox te enseñará un código: cópialo y pégalo aquí.',
    'addsrc.dropbox.open': 'Abrir Dropbox',
    'addsrc.dropbox.code': 'Código de Dropbox',
    'addsrc.dropbox.codePh': 'Pega aquí el código',
    'addsrc.dropbox.namePh': 'Mi Dropbox',
    'addsrc.onedrive.hint': 'Filoteca pide a Microsoft un permiso solo de lectura (no puede cambiar ni borrar nada) y lo puedes retirar cuando quieras desde tu cuenta. Al pulsar «Conectar» te daremos un código para escribir en una página de Microsoft, desde este aparato o desde el móvil.',
    'addsrc.onedrive.connect': 'Conectar con Microsoft',
    'addsrc.onedrive.codeIs': 'Escribe este código en la página de Microsoft',
    'addsrc.onedrive.waiting': 'Esperando a que lo apruebes… caduca en {min} min',
    'addsrc.onedrive.namePh': 'Mi OneDrive',
    'addsrc.cloud.folder': 'Carpeta (opcional)',
    'addsrc.cloud.folderPh': 'Cine/Películas',
    'addsrc.cloud.folderHelp': 'Si la dejas vacía se lee toda la cuenta. Con una carpeta, solo esa y lo que tenga dentro.',
    'addsrc.err.code': 'El código no es válido o ya se usó. Pulsa «Abrir Dropbox» y copia uno nuevo.',
    'addsrc.err.expired': 'El código ha caducado. Vuelve a empezar.',
    'addsrc.err.declined': 'Se ha rechazado el permiso en Microsoft.',
    'addsrc.err.offline': 'El servicio no ha dado permiso para mantener la conexión. Vuelve a intentarlo.',
    'addsrc.err.unconfigured': 'Esta nube todavía no está activada en esta versión de la app.',
    'addsrc.err.cloudauth': 'El permiso de la cuenta ya no vale. Vuelve a conectarla.',
    'settings.providerKind.dropbox': 'Nube · Dropbox',
    'settings.providerKind.onedrive': 'Nube · OneDrive',
    'addsrc.section.videos': 'Mis vídeos',
    'addsrc.section.tv': 'Televisión',
    'addsrc.help.title': '¿No sabes cuál elegir?',
    'addsrc.help.sub': 'Te ayudamos a encontrar la mejor opción según tu contenido.',
    'addsrc.help.intro': '¿Qué es lo que tienes?',
    'addsrc.help.device': 'Tengo vídeos en este móvil o en este PC',
    'addsrc.help.device.sub': 'Eliges una carpeta y Filoteca la ordena.',
    'addsrc.help.nas': 'Los tengo en un NAS o en otro ordenador de casa',
    'addsrc.help.nas.sub': 'Se conecta por la red de casa (SMB).',
    'addsrc.help.server': 'Uso Plex, Jellyfin o Emby',
    'addsrc.help.server.sub': 'O una carpeta web o WebDAV (Nextcloud, Synology…).',
    'addsrc.help.cloud': 'Los tengo en Dropbox o en OneDrive',
    'addsrc.help.cloud.sub': 'Entras con tu cuenta y solo se lee.',
    'addsrc.help.free': 'Quiero ver televisión en abierto',
    'addsrc.help.free.sub': 'Canales públicos y cine de dominio público.',
    'addsrc.help.list': 'Tengo una lista de canales de mi proveedor',
    'addsrc.help.list.sub': 'Una lista M3U o una cuenta Xtream que ya tienes.',
    'addsrc.group.device.step': 'Añade tus vídeos a Filoteca',
    'addsrc.group.network.step': 'Elige el tipo de conexión',
    'addsrc.group.cloud.step': 'Conecta tu almacenamiento',
    'addsrc.group.tv.step': 'Elige cómo quieres añadir la televisión',
    'addsrc.local.pickSub': 'Selecciona una carpeta de este dispositivo',
    'addsrc.local.note': 'Filoteca organizará automáticamente tus vídeos con carátulas, información y fichas.',
    'addsrc.netHelp.title': '¿Necesitas ayuda?',
    'addsrc.netHelp.sub': 'Te explicamos cómo conectar tu servidor.',
    'addsrc.cloud.note': 'Filoteca solo accederá a los archivos que autorices, y solo para leerlos.',
    'addsrc.onedrive.checking': 'Comprobando con Microsoft…',
    'addsrc.onedrive.approved': 'Aprobado. Conectando tu cuenta…',
    'addsrc.dropbox.connect': 'Conectar con Dropbox',
    'addsrc.dropbox.hintLoop': 'Filoteca pide a Dropbox un permiso solo de lectura (no puede cambiar ni borrar nada) y lo puedes retirar cuando quieras desde tu cuenta. Al pulsar «Conectar» se abrirá Dropbox en el navegador: acepta y vuelve aquí, se conecta solo.',
    'addsrc.onedrive.hintLoop': 'Filoteca pide a Microsoft un permiso solo de lectura (no puede cambiar ni borrar nada) y lo puedes retirar cuando quieras desde tu cuenta. Al pulsar «Conectar» se abrirá Microsoft en el navegador: inicia sesión, acepta y vuelve aquí, se conecta solo.',
    'addsrc.cloud.manual': '¿No vuelve solo? Usar un código',

    'src.title': 'Fuentes',
    'src.sub': 'Gestiona de dónde obtiene Filoteca tu contenido.',
    'src.f.all': 'Fuentes',
    'src.f.active': 'Activas',
    'src.f.issues': 'Con incidencias',
    'src.f.off': 'Desactivadas',
    'src.search': 'Buscar fuentes…',
    'src.view': 'Ver fuentes ({n})',
    'src.listTitle': 'Fuentes',
    'src.add': 'Añadir fuente',
    'src.free': 'Gratuito',
    'src.main': 'Principal',
    'src.inCatalog': 'En el catálogo',
    'src.retry': 'Reintentar',
    'src.updated': 'Actualizado',
    'src.lastTry': 'Último intento',
    'src.expires': 'Caduca en',
    'src.expiredLabel': 'Caducó',
    'src.days': '{n} días',
    'src.daysAgo': 'hace {n} días',
    'src.loadError': 'No se pudo cargar su catálogo',
    'src.empty': 'Ninguna fuente coincide.',
    'src.channels': 'canales',
    'src.movies': 'películas',
    'src.series': 'series',
    'src.detail': 'Fuente',
    'src.refresh': 'Actualizar catálogo',
    'src.refreshing': 'Actualizando…',
    'src.info': 'Información',
    'src.kind': 'Tipo',
    'src.server': 'Servidor',
    'src.connections': 'Conexiones en uso',
    'src.of': '{a} de {b}',
    'src.state': 'Estado',
    'src.ok': 'Correcto',
    'src.content': 'Contenido en el catálogo',
    'src.repeated': 'Títulos repetidos',
    'src.actions': 'Acciones',
    'src.edit': 'Editar fuente',
    'src.duplicate': 'Duplicar',
    'src.share': 'Compartir configuración',
    'src.delete': 'Eliminar fuente',
    'src.copySuffix': '(copia)',
    'src.duplicated': 'Fuente duplicada: {name}',
    'src.offBadge': 'Desactivada',
    'src.addShort': 'Añadir',
    'addsrc.group.network.web': 'Mis servidores',
    'addsrc.group.network.sub.web': 'Jellyfin, Emby, Plex o una carpeta web publicados en internet',
    'addsrc.group.network.step.web': 'Elige el tipo de servidor',

    'edit.menu': 'Editar ficha',
    'edit.title': 'Editar ficha',
    'edit.name': 'Título',
    'edit.year': 'Año',
    'edit.rating': 'Valoración',
    'edit.ratingHelp': 'De 0 a 10',
    'edit.age': 'Clasificación por edades',
    'edit.ageNone': 'Sin indicar',
    'edit.genre': 'Género',
    'edit.genrePh': 'Drama, Comedia',
    'edit.plot': 'Sinopsis',
    'edit.otherFrame': 'Otro fotograma',
    'edit.upload': 'Subir imagen',
    'edit.imageFailed': 'No se pudo leer esa imagen.',
    'edit.captureFailedHint': 'Puedes subir una imagen.',
    'edit.capturing': 'Buscando…',
    'edit.captureFailed': 'No se pudo sacar un fotograma de este vídeo.',
    'edit.saved': 'Ficha guardada',
    'edit.restore': 'Restaurar los datos originales',
    'edit.restored': 'Datos originales restaurados',
    'edit.err.name': 'Escribe un título.',
    'edit.err.year': 'El año tiene que ser de cuatro cifras (por ejemplo, 1998).',
    'edit.err.rating': 'La valoración va de 0 a 10.',
    'src.more': 'Ver más',
    'src.less': 'Ver menos',
    'spotify.connect': 'Conectar Spotify',
    'spotify.open': 'Abrir en Spotify',
    'spotify.intro': 'Conecta tu cuenta de Spotify Premium y la banda sonora sonará en el aparato donde tengas Spotify abierto: el móvil, un altavoz o esta misma tele.',
    'spotify.linkTitle': 'Conectar Spotify',
    'spotify.linkText': 'Escanea el código con el móvil o abre el enlace, entra en Spotify y vuelve aquí.',
    'spotify.openLink': 'Abrir el enlace',
    'spotify.waiting': 'Esperando a Spotify…',
    'spotify.linked': 'Spotify conectado como {name}',
    'spotify.searching': 'Buscando la banda sonora…',
    'spotify.notFound': 'No encuentro esta banda sonora en Spotify.',
    'spotify.noDevice': 'Abre Spotify en algún aparato (el móvil, un altavoz o la tele) y vuelve a intentarlo.',
    'spotify.pickDevice': 'Sonar en…',
    'spotify.playing': 'Sonando «{album}» en {device}',
    'spotify.premium': 'Para que suene desde aquí hace falta Spotify Premium.',
    'spotify.failed': 'Spotify no ha respondido. Prueba otra vez.',
    'spotify.setting': 'Spotify',
    'spotify.notLinked': 'No conectado · la banda sonora de cada película, en tus altavoces',
    'spotify.linkedSub': 'Conectado como {name}',
    'spotify.unlink': '¿Desconectar Spotify de este aparato?',
    'spotify.expired': 'La conexión con Spotify ha caducado: vuelve a conectarla.',
    'spotify.linkExpired': 'El enlace ha caducado. Vuelve a intentarlo.',
    'spotify.denied': 'No se ha dado permiso a Filoteca en Spotify.',
    'edit.tmdbLink': 'Enlazar con TMDB',
    'edit.tmdbHint': 'Busca la película o serie en TMDB y se rellenarán la carátula, el año, la valoración, el género y la sinopsis. Podrás cambiarlos antes de guardar.',
    'edit.tmdbNone': 'TMDB no ha encontrado nada. Prueba con otro título.',
    'edit.tmdbError': 'No se pudo consultar TMDB.',
    'edit.tmdbLinked': 'Enlazada con TMDB: {title}',
    'edit.tmdbUnlink': 'Quitar enlace',
    'edit.tmdbPicked': 'Datos de TMDB puestos; pulsa Guardar para quedarte con ellos',
    'addsrc.section.tools': 'Otras formas de añadir',
    'start.discoverSub': 'Jellyfin, Emby, Plex y otros servidores de tu wifi',
    'start.phoneSub': 'Teclea los datos en el móvil y aparecen aquí',
    'start.tvSub': 'Copia aquí las fuentes de una tele ya emparejada',
    'start.pairSub': 'Usa el móvil como mando y comparte sus fuentes',
    'settings.peekStyle': 'Dónde se amplía',
    'settings.peekStyleSub': 'En Películas y Series: dentro de la fila, como en Prime Video, o flotando encima con tráiler y sinopsis',
    'settings.peekStyle.row': 'Dentro de la fila',
    'settings.peekStyle.float': 'Flotante',
    'settings.cardsPosterOnly': 'Solo la carátula',
    'settings.cardsPosterOnlySub': 'Las películas y series se ven solo con su carátula, sin título ni nota debajo',
    'detail.links': 'Enlaces',
    'detail.imdbSearch': 'Buscar en IMDb',
    'settings.tmdbMode': 'Fichas con TMDB',
    'settings.tmdbModeSub': 'Completar las fichas con TMDB o usar solo lo que traen tus bibliotecas (Jellyfin, Emby, Plex…)',
    'settings.tmdbMode.auto': 'Completar lo que falte',
    'settings.tmdbMode.basics': 'Solo si faltan datos básicos',
    'detail.plotCredit': "Sinopsis adaptada de Wikipedia (CC BY-SA 4.0)",
    'catreview.title': "Revisar sinopsis",
    'catreview.sub': "Sinopsis generadas con IA a partir de Wikipedia. Revisa, corrige si hace falta y aprueba: se publican con su atribución CC BY-SA.",
    'catreview.empty': "No hay sinopsis pendientes de revisar.",
    'catreview.source': "Fuente",
    'catreview.article': "Artículo",
    'catreview.history': "Historial",
    'catreview.approve': "Aprobar",
    'catreview.reject': "Rechazar",
    'catreview.approveAll': "Aprobar las {n} visibles",
    'catreview.approveAllText': "Se aprobarán las {n} sinopsis visibles con el texto que ves. ¿Continuar?",
    'catreview.more': "Cargar más",
    'catreview.done': "{n} decididas",
    'catstatus.title': "Estado del catálogo",
    'catstatus.sub': "Obras, sinopsis, gasto de IA y trabajos",
    'catstatus.catalog': "Catálogo",
    'catstatus.works': "Obras",
    'catstatus.films': "Películas",
    'catstatus.series': "Series",
    'catstatus.people': "Personas",
    'catstatus.synopsis': "Sinopsis",
    'catstatus.approved': "Aprobadas",
    'catstatus.pending': "Por revisar",
    'catstatus.noPlot': "Sin argumento en Wikipedia",
    'catstatus.discarded': "Descartadas",
    'catstatus.ai': "IA",
    'catstatus.off': "apagada",
    'catstatus.cost': "Gasto de hoy",
    'catstatus.calls': "Llamadas de hoy",
    'catstatus.tokens': "Tokens de hoy",
    'catstatus.jobs': "Trabajos en marcha",
    'catstatus.idle': "Ahora mismo no hay ningún trabajo en marcha.",
    'catstatus.queued': "En cola",
    'catstatus.failed': "{n} trabajos fallidos en las últimas 24 h.",
    'catstatus.requests': "Peticiones de las apps",
    'catstatus.updated': "Actualizado",
    'catstatus.job.wikidata_expand': "Ampliar el catálogo",
    'catstatus.job.wikipedia_synopsis': "Generar sinopsis",
    'catstatus.job.request_resolve': "Atender peticiones",
    'catstatus.job.release_export': "Exportar edición",
    'catstatus.job.dataset_import': "Importar dataset",
    'catstatus.job.changes_prune': "Limpieza",
    'catstatus.job.tvmaze_supplement': "Complemento TVmaze",
    'catstatus.job.commons_candidates': "Candidatos de imágenes",
    'catstatus.job.intake_process': "Incorporación diaria",
    'catstatus.req.pending': "Pendientes",
    'catstatus.req.resolved': "Incorporadas",
    'catstatus.req.not_found': "No están en Wikidata",
    'catstatus.req.ambiguous': "Ambiguas",
    'catstatus.req.failed': "Fallidas",
    'catstatus.req.processing': "En proceso",
    'settings.catalogName': "Catálogo de Filoteca",
    'settings.catalogOn': "Catálogo de Filoteca",
    'settings.catalogOnSub': "Completar las fichas (reparto, dirección, géneros, duración…) con el catálogo de Filoteca. Solo se envía el identificador del título (IMDb/TMDB), nada tuyo",
    'settings.catalogAttribution': "Datos de Wikidata (CC0) servidos por el catálogo de Filoteca",
    'settings.tmdbMode.omdb': 'Usar OMDb si está configurado',
    'settings.tmdbMode.off': 'No usar TMDB',
    'settings.omdbAttribution': 'Valoraciones y premios de OMDb (licencia CC BY-NC 4.0). Sin relación con IMDb.',
    'detail.ratings': 'Valoraciones',
    'detail.awards': 'Premios',
    'settings.omdbWeb': 'Valoraciones de OMDb',
    'settings.omdbWebSub': 'IMDb, Rotten Tomatoes y Metacritic en las fichas (con la clave del servidor)'
};
